$(document).ready(function () {

    $.ajax({
        type: "GET",
        url: "/products/ro-hot-cold-water-dispenser-a1.js",
        dataType: "json",
        success: function (product) {
            var goods_price = (product.price / 100).toFixed(2);
            $(".wd-compare-product .wd-compare-detail-item")
                .eq(0)
                .find(".wd-compare-detail-item-product-price")
                .html("$" + goods_price);
            $(".wd-compare-header .wd-compare-header-item")
                .eq(0)
                .find(".wd-compare-header-item-price")
                .html("$" + goods_price);
        },
    });
    $.ajax({
        type: "GET",
        url: "/products/reverse-osmosis-hot-and-cold-water-dispenser-a2.js",
        dataType: "json",
        success: function (product) {
            var goods_price = (product.price / 100).toFixed(2);
            $(".wd-compare-product .wd-compare-detail-item")
                .eq(1)
                .find(".wd-compare-detail-item-product-price")
                .html("$" + goods_price);
            $(".wd-compare-header .wd-compare-header-item")
                .eq(1)
                .find(".wd-compare-header-item-price")
                .html("$" + goods_price);
        },
    });
    $.ajax({
        type: "GET",
        url: "/products/countertop-ro-water-filter-system-wd-k19-s.js",
        dataType: "json",
        success: function (product) {
            var goods_price = (product.price / 100).toFixed(2);
            $(".wd-compare-product .wd-compare-detail-item")
                .eq(2)
                .find(".wd-compare-detail-item-product-price")
                .html("$" + goods_price);
            $(".wd-compare-header .wd-compare-header-item")
                .eq(2)
                .find(".wd-compare-header-item-price")
                .html("$" + goods_price);
        },
    });
    $(window).on('scroll', function () {
        var scrollTop = $(this).scrollTop();
        var offsetTop = $('.wd-compare-content').offset().top;
        if (scrollTop > offsetTop) {
            $('.wd-compare-header').css('display', 'block')
        } else {
            $('.wd-compare-header').css('display', 'none')
        }
    });

    var wd_compare_index;
    var pre_index;

    var window_width = $(window).width();
    if (window_width <= 1024) {
        $(".wd-compare-product .wd-compare-detail-item-product-choose-card-items")
            .eq(0)
            .find(".wd-compare-detail-item-product-choose-card-item")
            .eq(2)
            .removeClass("wd-compare-detail-item-product-choose-card-item-choosed");
        $(".wd-compare-product .wd-compare-detail-item-product-choose-card-items")
            .eq(1)
            .find(".wd-compare-detail-item-product-choose-card-item")
            .eq(2)
            .removeClass("wd-compare-detail-item-product-choose-card-item-choosed");
    }

    $(".wd-compare-detail-item-product-choose-select").click(function () {
        wd_compare_index = $(this).parents(".wd-compare-detail-item").index();
        pre_index = $(this)
            .siblings(".wd-compare-detail-item-product-choose-card")
            .find(`.wd-compare-detail-item-product-choose-card-item-active`)
            .attr("data-index");

        if (window_width <= 767) {
            $(".wd-compare-detail-item-product-choose-card-popup").css(
                "display",
                "block"
            );
            $(".wd-compare-detail-item-product-choose-select-mobile").css(
                "display",
                "flex"
            );
            $(".wd-compare-detail-item-product-choose-card-popup-close").css(
                "display",
                "block"
            );
            $("html").css("overflow", "hidden");
            $('.wd-compare').css('z-index', '99');
            $(this)
                .siblings(".wd-compare-detail-item-product-choose-select-mobile")
                .css("border-bottom", "1px solid #2179CA");
            $(this)
                .parents(".wd-compare-detail-item")
                .siblings()
                .find(".wd-compare-detail-item-product-choose-select-mobile")
                .css("border-bottom", "1px solid #e2e2e2");
        }
        $(this)
            .parents(".wd-compare-detail-items")
            .find(".wd-compare-detail-item-product-choose-card")
            .stop()
            .slideUp();
        $(this)
            .siblings(".wd-compare-detail-item-product-choose-card")
            .stop()
            .slideDown();
    });

    $(
        ".wd-compare-detail-item-product-choose-select.wd-compare-detail-item-product-choose-select-mobile"
    ).click(function () {
        $(this)
            .parents(".wd-compare-detail-item")
            .siblings()
            .find(".wd-compare-detail-item-product-choose-card")
            .css("display", "none");
        $(this)
            .parents(".wd-compare-detail-item")
            .siblings()
            .find(".wd-compare-detail-item-product-choose-select-mobile")
            .css("border-bottom", "1px solid #e2e2e2");
        $(this)
            .siblings(".wd-compare-detail-item-product-choose-card")
            .css("display", "block");
        $(this).css("border-bottom", "1px solid #2179CA");
    });

    $(".wd-compare-detail-item-product-choose-card").mouseleave(function () {
        $(this).stop().slideUp();
    });
    $(".wd-compare-detail-item-product-choose-card-item").hover(
        function () {
            $(this).addClass("wd-compare-detail-item-product-choose-card-item-hover");
        },
        function () {
            $(this).removeClass(
                "wd-compare-detail-item-product-choose-card-item-hover"
            );
        }
    );
    $(".wd-compare-detail-item-product-choose-card-popup-close").click(
        function () {
            $(this)
                .parents(".wd-compare-detail-items")
                .find(".wd-compare-detail-item-product-choose-card")
                .stop()
                .slideUp();
            $(".wd-compare-detail-item-product-choose-card-popup").css(
                "display",
                "none"
            );
            $(".wd-compare-detail-item-product-choose-select-mobile").css(
                "display",
                "none"
            );
            $(".wd-compare-detail-item-product-choose-card-popup-close").css(
                "display",
                "none"
            );
            $("html").css("overflow", "auto");
            $(".wd-compare").css("z-index", "auto");
        }
    );

    $(".wd-compare-detail-item-product-choose-card-item").click(function () {
        if (
            $(this).hasClass(
                "wd-compare-detail-item-product-choose-card-item-choosed"
            )
        ) {
            return false;
        }
        if (window_width <= 1024) {
            $(this)
                .parents(".wd-compare-detail-items")
                .find(".wd-compare-detail-item-product-choose-card")
                .stop()
                .slideUp();
            $('.wd-compare').css('z-index', 'auto');
        }
        if (window_width <= 767) {
            $(this)
                .parents(".wd-compare-detail-items")
                .find(".wd-compare-detail-item-product-choose-card")
                .stop()
                .slideUp();
            $(".wd-compare-detail-item-product-choose-card-popup").css(
                "display",
                "none"
            );
            $(".wd-compare-detail-item-product-choose-select-mobile").css(
                "display",
                "none"
            );
            $(".wd-compare-detail-item-product-choose-card-popup-close").css(
                "display",
                "none"
            );
            $("html").css("overflow", "auto");
        }

        var data_index = $(this).attr("data-index");
        if (data_index !== pre_index) {
            $(".wd-compare-detail-item-product-choose-card-items")
                .find(`[data-index="${pre_index}"]`)
                .removeClass("wd-compare-detail-item-product-choose-card-item-choosed");
            pre_index = data_index;
        }
        $(this)
            .siblings()
            .removeClass("wd-compare-detail-item-product-choose-card-item-active");
        $(this).addClass("wd-compare-detail-item-product-choose-card-item-active");
        $(this).removeClass(
            "wd-compare-detail-item-product-choose-card-item-choosed"
        );
        $(this)
            .parents(".wd-compare-detail-item")
            .siblings()
            .find(".wd-compare-detail-item-product-choose-card-item")
            .each(function () {
                if ($(this).attr("data-index") === data_index) {
                    $(this).addClass(
                        "wd-compare-detail-item-product-choose-card-item-choosed"
                    );
                }
            });

        var product_title = $(this)
            .find(".wd-compare-detail-item-product-choose-card-item-title")
            .html()
            .trim();

        $(this)
            .parents(".wd-compare-detail-item-product-choose")
            .find(
                ".wd-compare-detail-item-product-choose-select .wd-compare-detail-item-product-choose-name"
            )
            .html(product_title);

        $(this)
            .parents(".wd-compare")
            .find(".wd-compare-header-item")
            .eq(wd_compare_index)
            .find(".wd-compare-header-item-title")
            .html(product_title);
        var product_value = $(this).data("value");
        $.ajax({
            type: "GET",
            url: "/products/" + product_value + ".js",
            dataType: "json",
            success: function (product) {
                var goods_price = (product.price_max / 100).toFixed(2);
                var goods_url = product.url;
                $(".wd-compare-product .wd-compare-detail-item")
                    .eq(wd_compare_index)
                    .find(".wd-compare-detail-item-product-price")
                    .html("$" + goods_price);
                $(".wd-compare-header .wd-compare-header-item")
                    .eq(wd_compare_index)
                    .find(".wd-compare-header-item-price")
                    .html("$" + goods_price);
            },
        });

        edit_info(product_title);
    });

    function edit_info(title) {
        if (title == "G3P800") {
            $(".wd-compare-header .wd-compare-header-item")
                .eq(wd_compare_index)
                .find(".wd-compare-header-item-img img")
                .attr(
                    "src",
                    "https://cdn.shopify.com/s/files/1/0078/6156/7570/files/ui-wd-g3p800-w-new.png?v=1665970427"
                );
            $(".wd-compare-product .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-product-img img")
                .attr(
                    "src",
                    "https://cdn.shopify.com/s/files/1/0078/6156/7570/files/ui-wd-g3p800-w-new.png?v=1665970427"
                );
            $(".wd-compare-product .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-product-shop a")
                .attr(
                    "href",
                    "https://www.waterdropfilter.com/collections/reverse-osmosis-water-filter-all/products/tankless-reverse-osmosis-system-wd-g3p800-w-fc-1"
                );
            $(".wd-compare-detail-pure .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-3_1-svg.svg?v=1682313834" alt="">`
                );
            $(".wd-compare-detail-flow_capacity .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-text")
                .html("800 GPD");
            $(".wd-compare-detail-flow_rate .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-text")
                .html("0.56 GPM");
            $(".wd-compare-detail-flow_rate .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg_text")
                .html(`<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-flow-svg.svg?v=1682313834" alt="">
  6s`);
            $(".wd-compare-detail-flow_rate .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-subtext-oz")
                .html(`*The capacity of the glass is 8oz`);

            $(".wd-compare-detail-water_capacity_options .wd-compare-detail-item")
                .eq(wd_compare_index)
                .html(
                    `<div class="wd-compare-detail-item-svg"><img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-water_capacity_none-svg.svg?v=1682313834" alt=""></div>`
                );
            $(".wd-compare-detail-dispensing_option .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .eq(0)
                .html(
                    ` <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dispensing-svg.svg?v=1682313834" alt="">`
                );
            $(".wd-compare-detail-dispensing_option .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .eq(1)
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dispensing_none-svg.svg?v=1682313835" alt="">`
                );
            $(".wd-compare-detail-dispensing_option .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .eq(2)
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dispensing_none-svg.svg?v=1682313835" alt="">`
                );
            $(".wd-compare-detail-water .wd-compare-detail-item")
                .eq(wd_compare_index)
                .html(
                    `<div class="wd-compare-detail-item-svg"><img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-water-tank_none.svg?v=1682315144" alt=""></div>`
                );
            $(".wd-compare-detail-installation .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`
      <div class="wd-compare-detail-item-svg">
      <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-installation-1-svg.svg?v=1682313834" alt="">
  </div>
  <div class="wd-compare-detail-item-subtext">
      Need Installation
  </div>
  <div class="wd-compare-detail-item-svg">
      <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-installation-2-svg.svg?v=1682313834" alt="">
  </div>
  <div class="wd-compare-detail-item-subtext">
      Drill a hole in the countertop
  </div>
    `);
            $(".wd-compare-detail-dimensions .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-text")
                .html(`18.06”*5.65”*17.75”`);
            $(".wd-compare-detail-item_weight .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-text")
                .html(`32.4lb`);
            $(".wd-compare-detail-warranty .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-text")
                .html(`1 Year`);
            $(".wd-compare-detail-usage_scenario .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-usage_scenario-svg1.svg?v=1682313834" alt="">`
                );
            $(".wd-compare-detail-usage_scenario .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-text")
                .html(`Undersink`);

            $(".wd-compare-detail-nsf .wd-compare-detail-item").eq(wd_compare_index)
                .html(`<div class="wd-compare-detail-item-img">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-page-icon-8.png?v=1685341817"
            alt="">
    </div>`);

            $(".wd-compare-detail-fcc .wd-compare-detail-item").eq(wd_compare_index)
                .html(`<div class="wd-compare-detail-item-img">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-page-icon-2.png?v=1681377284"
            alt="">
    </div>`);

            $(".wd-compare-detail-ce .wd-compare-detail-item").eq(wd_compare_index)
                .html(`<div class="wd-compare-detail-item-img">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-page-icon-3.png?v=1681377284"
            alt="">
    </div>`);

            $(".wd-compare-detail-reddot_design .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`<div class="wd-compare-detail-item-img">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-page-icon-4.png?v=1681377284"
            alt="">
    </div>`);

            $(".wd-compare-detail-sgs .wd-compare-detail-item").eq(wd_compare_index)
                .html(`<div class="wd-compare-detail-item-img">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-page-icon-5.png?v=1681377284"
            alt="">
    </div>`);

            $(".wd-compare-detail-tuv .wd-compare-detail-item").eq(wd_compare_index)
                .html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835" alt="">
    </div>`);

            $(".wd-compare-detail-ul .wd-compare-detail-item").eq(wd_compare_index)
                .html(` <div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835" alt="">
    </div>`);

            $(".wd-compare-detail-filtration .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-bigtext")
                .html(`9 Stages`);
            $(".wd-compare-detail-reduce .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-reduce-svg.svg?v=1682313834" alt="">
    </div>
    <div class="wd-compare-detail-item-text">
        99.9% UV Sterilization Rate
    </div>
    <div class="wd-compare-detail-item-longtext">
        TDS, PFAS, fluoride, chlorine, inorganic arsenic compounds, salts like nitrate and
        chloride, viruses, bacteria, and other harmful substances<br><br>
        Heavy metals: chromium, lead, arsenic, iron, radium, and calcium<br><br>
        Dirt, dust, sand, chlorine, taste and odor, colloid, residual large particles, suspended
        solids, rust, sediment, large particles,
        scale
    </div>
    <div class="wd-compare-detail-item-a">
        <a
            href="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/Specification_Sheet_for_Reducing_Harmful_Substances-WD-G3P600-and-G3P800.pdf?v=1677668629">View
            the report ></a>
    </div>`);

            $(".wd-compare-detail-filter_life_span .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`<div class="wd-compare-detail-item-a">
    <a href="https://www.waterdropfilter.com/products/wd-g3-n1cf">
        <div class="wd-compare-detail-item-img">
            <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/ui-wd-g3-cf.png?v=1678334284"
                alt="">
        </div>
        <div class="wd-compare-detail-item-text">
            WD-G3-N1CF
        </div>
        <div class="wd-compare-detail-item-text">
            CF-6 Mths
        </div>
    </a>
  </div>
  <div class="wd-compare-detail-item-a">
    <a href="https://www.waterdropfilter.com/products/wd-g3-n3cb">
        <div class="wd-compare-detail-item-img">
            <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/ui-wd-g3-cb.png?v=1678334284"
                alt="">
        </div>
        <div class="wd-compare-detail-item-text">
            WD-G3-N3CB
        </div>
        <div class="wd-compare-detail-item-text">
            CB-12 Mths
        </div>
    </a>
  </div>
  <div class="wd-compare-detail-item-a">
    <a href=" https://www.waterdropfilter.com/products/wd-g3p800-n2ro-for-g3p800-reverse-osmosis-system">
        <div class="wd-compare-detail-item-img">
            <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/ui-wd-g3p800-ro.png?v=1678334285"
                alt="">
        </div>
        <div class="wd-compare-detail-item-text">
            WD-G3P800-N2RO
        </div>
        <div class="wd-compare-detail-item-text">
            RO-24 Mths
        </div>
    </a>
  </div>`);

            $(".wd-compare-detail-average .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-text")
                .html(`$159.97`);

            $(".wd-compare-detail-filter_life .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-filter.svg?v=1682313834" alt="">`
                );

            $(".wd-compare-detail-tds .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-tds-svg.svg?v=1682313834" alt="">`
                );

            $(".wd-compare-detail-temperature .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    ` <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-smart_none-svg.svg?v=1682313834" alt="">`
                );

            $(".wd-compare-detail-uv .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-uv-svg.svg?v=1682313835" alt="">`
                );

            $(".wd-compare-detail-self .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-self-svg.svg?v=1682313834" alt="">`
                );


            $(".wd-compare-detail-adjustable .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    ` <img src=https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-contrast-ro-product-icon4.png?v=1715067027" alt="">`
                );
            $(".wd-compare-detail-sound .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-sound-svg.svg?v=1682313834" alt="">`
                );
        } else if (title == "G3P600") {
            $(".wd-compare-header .wd-compare-header-item")
                .eq(wd_compare_index)
                .find(".wd-compare-header-item-img img")
                .attr(
                    "src",
                    "https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-product-page-wd-g3p600-product-g3p600.png"
                );
            $(".wd-compare-product .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-product-img img")
                .attr(
                    "src",
                    "https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-product-page-wd-g3p600-product-g3p600.png"
                );
            $(".wd-compare-product .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-product-shop a")
                .attr(
                    "href",
                    "https://www.waterdropfilter.com/collections/reverse-osmosis-water-filter-all/products/tankless-reverse-osmosis-system-g3p600"
                );
            $(".wd-compare-detail-pure .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-2_1-svg.svg?v=1682313834" alt="">`
                );
            $(".wd-compare-detail-flow_capacity .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-text")
                .html("600 GPD");
            $(".wd-compare-detail-flow_rate .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-text")
                .html("0.42 GPM");
            $(".wd-compare-detail-flow_rate .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg_text")
                .html(`<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-flow-svg.svg?v=1682313834" alt="">
  8s`);
            $(".wd-compare-detail-flow_rate .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-subtext-oz")
                .html(`*The capacity of the glass is 8oz`);
            $(".wd-compare-detail-water_capacity_options .wd-compare-detail-item")
                .eq(wd_compare_index)
                .html(
                    `<div class="wd-compare-detail-item-svg"><img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-water_capacity_none-svg.svg?v=1682313834" alt=""></div>`
                );
            $(".wd-compare-detail-dispensing_option .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .eq(0)
                .html(
                    ` <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dispensing-svg.svg?v=1682313834" alt="">`
                );
            $(".wd-compare-detail-dispensing_option .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .eq(1)
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dispensing_none-svg.svg?v=1682313835" alt="">`
                );
            $(".wd-compare-detail-dispensing_option .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .eq(2)
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dispensing_none-svg.svg?v=1682313835" alt="">`
                );
            $(".wd-compare-detail-water .wd-compare-detail-item")
                .eq(wd_compare_index)
                .html(
                    `<div class="wd-compare-detail-item-svg"><img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-water-tank_none.svg?v=1682315144" alt=""></div>`
                );
            $(".wd-compare-detail-installation .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`
      <div class="wd-compare-detail-item-svg">
      <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-installation-1-svg.svg?v=1682313834" alt="">
  </div>
  <div class="wd-compare-detail-item-subtext">
      Need Installation
  </div>
  <div class="wd-compare-detail-item-svg">
      <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-installation-2-svg.svg?v=1682313834" alt="">
  </div>
  <div class="wd-compare-detail-item-subtext">
      Drill a hole in the countertop
  </div>
    `);
            $(".wd-compare-detail-dimensions .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-text")
                .html(`18.11”*5.67”*17.73”`);
            $(".wd-compare-detail-item_weight .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-text")
                .html(`32.4lb`);
            $(".wd-compare-detail-warranty .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-text")
                .html(`1 Year`);
            $(".wd-compare-detail-usage_scenario .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-usage_scenario-svg1.svg?v=1682313834" alt="">`
                );
            $(".wd-compare-detail-usage_scenario .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-text")
                .html(`Undersink`);

            $(".wd-compare-detail-nsf .wd-compare-detail-item").eq(wd_compare_index)
                .html(`<div class="wd-compare-detail-item-img">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-page-icon-8.png?v=1685341817"
            alt="">
    </div>`);

            $(".wd-compare-detail-fcc .wd-compare-detail-item").eq(wd_compare_index)
                .html(`<div class="wd-compare-detail-item-img">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-page-icon-2.png?v=1681377284"
            alt="">
    </div>`);

            $(".wd-compare-detail-ce .wd-compare-detail-item").eq(wd_compare_index)
                .html(`<div class="wd-compare-detail-item-img">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-page-icon-3.png?v=1681377284"
            alt="">
    </div>`);

            $(".wd-compare-detail-reddot_design .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`<div class="wd-compare-detail-item-img">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-page-icon-4.png?v=1681377284"
            alt="">
    </div>`);

            $(".wd-compare-detail-sgs .wd-compare-detail-item").eq(wd_compare_index)
                .html(`<div class="wd-compare-detail-item-img">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-page-icon-5.png?v=1681377284"
            alt="">
    </div>`);

            $(".wd-compare-detail-tuv .wd-compare-detail-item").eq(wd_compare_index)
                .html(`<div class="wd-compare-detail-item-img">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-page-icon-6.png?v=1681377284" alt="">
    </div>`);

            $(".wd-compare-detail-ul .wd-compare-detail-item").eq(wd_compare_index)
                .html(` <div class="wd-compare-detail-item-img">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-page-icon-7.png?v=1681377284" alt="">
    </div>`);

            $(".wd-compare-detail-filtration .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-bigtext")
                .html(`8   Stages`);
            $(".wd-compare-detail-reduce .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-reduce_none-svg.svg?v=1682313834" alt="">
     </div>
    <div class="wd-compare-detail-item-longtext">
        TDS, PFAS, fluoride, chlorine, inorganic arsenic compounds, salts like nitrate and
        chloride, viruses, bacteria, and other harmful substances<br><br>
        Heavy metals: chromium, lead, arsenic, iron, radium, and calcium<br><br>
        Dirt, dust, sand, chlorine, taste and odor, colloid, residual large particles, suspended
        solids, rust, sediment, large particles,
        scale
    </div>
    <div class="wd-compare-detail-item-a">
        <a
            href="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/Specification_Sheet_for_Reducing_Harmful_Substances-WD-G3P600-and-G3P800.pdf?v=1677668629">View
            the report ></a>
    </div>`);

            $(".wd-compare-detail-filter_life_span .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`<div class="wd-compare-detail-item-a">
    <a href="https://www.waterdropfilter.com/products/wd-g3-n1cf">
        <div class="wd-compare-detail-item-img">
            <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/ui-wd-g3-cf.png?v=1678334284"
                alt="">
        </div>
        <div class="wd-compare-detail-item-text">
            WD-G3-N1CF
        </div>
        <div class="wd-compare-detail-item-text">
            CF-6 Mths
        </div>
    </a>
  </div>
  <div class="wd-compare-detail-item-a">
    <a href="https://www.waterdropfilter.com/products/wd-g3-n3cb">
        <div class="wd-compare-detail-item-img">
            <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/ui-wd-g3-cb.png?v=1678334284"
                alt="">
        </div>
        <div class="wd-compare-detail-item-text">
            WD-G3-N3CB
        </div>
        <div class="wd-compare-detail-item-text">
            CB-12 Mths
        </div>
    </a>
  </div>
  <div class="wd-compare-detail-item-a">
    <a href="https://www.waterdropfilter.com/products/g3p600-ro-system-replacement-filters">
        <div class="wd-compare-detail-item-img">
            <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/ui-wd-g3p600-ro.png?v=1678334285"
                alt="">
        </div>
        <div class="wd-compare-detail-item-text">
        WD-G3P600-N2RO
        </div>
        <div class="wd-compare-detail-item-text">
            RO-24 Mths
        </div>
    </a>
  </div>`);

            $(".wd-compare-detail-average .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-text")
                .html(`$144.97`);

            $(".wd-compare-detail-filter_life .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-filter.svg?v=1682313834" alt="">`
                );

            $(".wd-compare-detail-tds .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-tds-svg.svg?v=1682313834" alt="">`
                );

            $(".wd-compare-detail-temperature .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    ` <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-smart_none-svg.svg?v=1682313834" alt="">`
                );

            $(".wd-compare-detail-uv .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-smart_none-svg.svg?v=1682313834" alt="">`
                );

            $(".wd-compare-detail-self .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-self-svg.svg?v=1682313834" alt="">`
                );


            $(".wd-compare-detail-adjustable .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    ` <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-smart_none-svg.svg?v=1682313834" alt="">`
                );
            $(".wd-compare-detail-sound .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-sound-svg.svg?v=1682313834" alt="">`
                );
        } else if (title == "K6") {
            $(".wd-compare-header .wd-compare-header-item")
                .eq(wd_compare_index)
                .find(".wd-compare-header-item-img img")
                .attr(
                    "src",
                    "https://cdn.shopify.com/s/files/1/0078/6156/7570/files/ui-wd-k6-w-new_1.png"
                );
            $(".wd-compare-product .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-product-img img")
                .attr(
                    "src",
                    "https://cdn.shopify.com/s/files/1/0078/6156/7570/files/ui-wd-k6-w-new_1.png"
                );
            $(".wd-compare-product .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-product-shop a")
                .attr(
                    "href",
                    "https://www.waterdropfilter.com/collections/reverse-osmosis-water-filter-all/products/reverse-osmosis-instant-hot-water-dispenser-system-wd-k6-w"
                );
            $(".wd-compare-detail-pure .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-2_1-svg.svg?v=1682313834" alt="">`
                );
            $(".wd-compare-detail-flow_capacity .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-text")
                .html("600 GPD");
            $(".wd-compare-detail-flow_rate .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-text")
                .html("0.42 GPM");
            $(".wd-compare-detail-flow_rate .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg_text")
                .html(`<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-flow-svg.svg?v=1682313834" alt="">
  8s`);
            $(".wd-compare-detail-flow_rate .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-subtext-oz")
                .html(`*The capacity of the glass is 8oz`);
            $(".wd-compare-detail-water_capacity_options .wd-compare-detail-item")
                .eq(wd_compare_index)
                .html(
                    `<div class="wd-compare-detail-item-svg"><img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-water_capacity_none-svg.svg?v=1682313834" alt=""></div>`
                );
            $(".wd-compare-detail-dispensing_option .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .eq(0)
                .html(
                    ` <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dispensing-svg.svg?v=1682313834" alt="">`
                );
            $(".wd-compare-detail-dispensing_option .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .eq(1)
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dispensing-svg.svg?v=1682313834" alt="">`
                );
            $(".wd-compare-detail-dispensing_option .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .eq(2)
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dispensing_none-svg.svg?v=1682313835" alt="">`
                );
            $(".wd-compare-detail-water .wd-compare-detail-item")
                .eq(wd_compare_index)
                .html(
                    `<div class="wd-compare-detail-item-svg"><img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-water-tank_none.svg?v=1682315144" alt=""></div>`
                );
            $(".wd-compare-detail-installation .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`
      <div class="wd-compare-detail-item-svg">
      <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-installation-1-svg.svg?v=1682313834" alt="">
  </div>
  <div class="wd-compare-detail-item-subtext">
      Need Installation
  </div>
  <div class="wd-compare-detail-item-svg">
      <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-installation-2-svg.svg?v=1682313834" alt="">
  </div>
  <div class="wd-compare-detail-item-subtext">
      Drill a hole in the countertop
  </div>
  
    `);
            $(".wd-compare-detail-dimensions .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-text")
                .html(`18”*17”*7”`);
            $(".wd-compare-detail-item_weight .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-text")
                .html(`31.9lb`);
            $(".wd-compare-detail-warranty .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-text")
                .html(`1 Year`);
            $(".wd-compare-detail-usage_scenario .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-usage_scenario-svg1.svg?v=1682313834" alt="">`
                );
            $(".wd-compare-detail-usage_scenario .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-text")
                .html(`Undersink`);

            $(".wd-compare-detail-nsf .wd-compare-detail-item").eq(wd_compare_index)
                .html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835"
            alt="">
    </div>`);

            $(".wd-compare-detail-fcc .wd-compare-detail-item").eq(wd_compare_index)
                .html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835"
            alt="">
    </div>`);

            $(".wd-compare-detail-ce .wd-compare-detail-item").eq(wd_compare_index)
                .html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835"
            alt="">
    </div>`);

            $(".wd-compare-detail-reddot_design .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835"
            alt="">
    </div>`);

            $(".wd-compare-detail-sgs .wd-compare-detail-item").eq(wd_compare_index)
                .html(`<div class="wd-compare-detail-item-img">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-page-icon-5.png?v=1681377284"
            alt="">
    </div>`);

            $(".wd-compare-detail-tuv .wd-compare-detail-item").eq(wd_compare_index)
                .html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835" alt="">
    </div>`);

            $(".wd-compare-detail-ul .wd-compare-detail-item").eq(wd_compare_index)
                .html(` <div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835" alt="">
    </div>`);

            $(".wd-compare-detail-filtration .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-bigtext")
                .html(`5 Stages`);
            $(".wd-compare-detail-reduce .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-reduce_none-svg.svg?v=1682313834" alt="">
    </div>
    <div class="wd-compare-detail-item-longtext">
        TDS, PFAS, fluoride, chlorine, inorganic arsenic compounds, salts like nitrate and
        chloride, viruses, bacteria, and other harmful substances<br><br>
        Heavy metals: chromium, lead, arsenic, iron, radium, and calcium<br><br>
        Dirt, dust, sand, chlorine, taste and odor, colloid, residual large particles, suspended
        solids, rust, sediment, large particles,
        scale
    </div>
    <div class="wd-compare-detail-item-a">
        <a
            href="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/Specification_Sheet_for_Reducing_Harmful_Substances-WD-K6.pdf?v=1677668629">View
            the report ></a>
    </div>
    `);

            $(".wd-compare-detail-filter_life_span .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`<div class="wd-compare-detail-item-a">
    <a href="https://www.waterdropfilter.com/products/kjf-filter-for-waterdrop-k6-instant-hot-ro-system-wd-kjf">
        <div class="wd-compare-detail-item-img">
            <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/ui-wd-kjf.png?v=1678343818"
                alt="">
        </div>
        <div class="wd-compare-detail-item-text">
        WD-KJF
        </div>
        <div class="wd-compare-detail-item-text">
        KJF-12 Mths
        </div>
    </a>
  </div>`);

            $(".wd-compare-detail-average .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-text")
                .html(`$119.00`);

            $(".wd-compare-detail-filter_life .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-filter.svg?v=1682313834" alt="">`
                );

            $(".wd-compare-detail-tds .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-tds-svg.svg?v=1682313834" alt="">`
                );

            $(".wd-compare-detail-temperature .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    ` <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-temperature-svg.svg?v=1682313834" alt="">`
                );

            $(".wd-compare-detail-uv .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-smart_none-svg.svg?v=1682313834" alt="">`
                );

            $(".wd-compare-detail-self .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-self-svg.svg?v=1682313834" alt="">`
                );


            $(".wd-compare-detail-adjustable .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    ` <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-smart_none-svg.svg?v=1682313834" alt="">`
                );
            $(".wd-compare-detail-sound .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-sound-svg.svg?v=1682313834" alt="">`
                );
        } else if (title == "G2P600") {
            $(".wd-compare-header .wd-compare-header-item")
                .eq(wd_compare_index)
                .find(".wd-compare-header-item-img img")
                .attr(
                    "src",
                    "https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-page-find-your-water-filter-wd-g2p600-w.png"
                );
            $(".wd-compare-product .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-product-img img")
                .attr(
                    "src",
                    "https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-page-find-your-water-filter-wd-g2p600-w.png"
                );
            $(".wd-compare-product .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-product-shop a")
                .attr(
                    "href",
                    "https://www.waterdropfilter.com/products/reverse-osmosis-water-filtration-system-for-home-wd-g2600-w"
                );
            $(".wd-compare-detail-pure .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-2_1-svg.svg?v=1682313834" alt="">`
                );
            $(".wd-compare-detail-flow_capacity .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-text")
                .html("600 GPD");
            $(".wd-compare-detail-flow_rate .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-text")
                .html("0.42 GPM");
            $(".wd-compare-detail-flow_rate .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg_text")
                .html(`<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-flow-svg.svg?v=1682313834" alt="">
  8s`);
            $(".wd-compare-detail-flow_rate .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-subtext-oz")
                .html(`*The capacity of the glass is 8oz`);
            $(".wd-compare-detail-water_capacity_options .wd-compare-detail-item")
                .eq(wd_compare_index)
                .html(
                    `<div class="wd-compare-detail-item-svg"><img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-water_capacity_none-svg.svg?v=1682313834" alt=""></div>`
                );
            $(".wd-compare-detail-dispensing_option .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .eq(0)
                .html(
                    ` <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dispensing-svg.svg?v=1682313834" alt="">`
                );
            $(".wd-compare-detail-dispensing_option .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .eq(1)
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dispensing_none-svg.svg?v=1682313835" alt="">`
                );
            $(".wd-compare-detail-dispensing_option .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .eq(2)
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dispensing_none-svg.svg?v=1682313835" alt="">`
                );
            $(".wd-compare-detail-water .wd-compare-detail-item")
                .eq(wd_compare_index)
                .html(
                    `<div class="wd-compare-detail-item-svg"><img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-water-tank_none.svg?v=1682315144" alt=""></div>`
                );
            $(".wd-compare-detail-installation .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`
      <div class="wd-compare-detail-item-svg">
      <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-installation-1-svg.svg?v=1682313834" alt="">
  </div>
  <div class="wd-compare-detail-item-subtext">
      Need Installation
  </div>
  <div class="wd-compare-detail-item-svg">
      <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-installation-2-svg.svg?v=1682313834" alt="">
  </div>
  <div class="wd-compare-detail-item-subtext">
      Drill a hole in the countertop
  </div>
    `);
            $(".wd-compare-detail-dimensions .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-text")
                .html(`17.3”*5.9”*13.9”`);
            $(".wd-compare-detail-item_weight .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-text")
                .html(`20.94lb`);
            $(".wd-compare-detail-warranty .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-text")
                .html(`1 Year`);
            $(".wd-compare-detail-usage_scenario .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-usage_scenario-svg1.svg?v=1682313834" alt="">`
                );
            $(".wd-compare-detail-usage_scenario .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-text")
                .html(`Undersink`);

            $(".wd-compare-detail-nsf .wd-compare-detail-item").eq(wd_compare_index)
                .html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835"
            alt="">
    </div>`);

            $(".wd-compare-detail-fcc .wd-compare-detail-item").eq(wd_compare_index)
                .html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835"
            alt="">
    </div>`);

            $(".wd-compare-detail-ce .wd-compare-detail-item").eq(wd_compare_index)
                .html(`<div class="wd-compare-detail-item-img">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-page-icon-3.png?v=1681377284"
            alt="">
    </div>`);

            $(".wd-compare-detail-reddot_design .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835"
            alt="">
    </div>`);

            $(".wd-compare-detail-sgs .wd-compare-detail-item").eq(wd_compare_index)
                .html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835"
            alt="">
    </div>`);

            $(".wd-compare-detail-tuv .wd-compare-detail-item").eq(wd_compare_index)
                .html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835" alt="">
    </div>`);

            $(".wd-compare-detail-ul .wd-compare-detail-item").eq(wd_compare_index)
                .html(` <div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835" alt="">
    </div>`);

            $(".wd-compare-detail-filtration .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-bigtext")
                .html(`7 Stages`);
            $(".wd-compare-detail-reduce .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-reduce_none-svg.svg?v=1682313834" alt="">
    </div>
    <div class="wd-compare-detail-item-longtext">
        TDS, PFAS, fluoride, chlorine, inorganic arsenic compounds, salts like nitrate and
        chloride, viruses, bacteria, and other harmful substances<br><br>
        Heavy metals: chromium, lead, arsenic, iron, radium, and calcium<br><br>
        Dirt, dust, sand, chlorine, taste and odor, colloid, residual large particles, suspended
        solids, rust, sediment, large particles,
        scale
    </div>
    `);

            $(".wd-compare-detail-filter_life_span .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`<div class="wd-compare-detail-item-a">
    <a href="https://www.waterdropfilter.com/products/wd-g2cf-filter-for-wd-g2-reverse-osmosis-system">
        <div class="wd-compare-detail-item-img">
            <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-product-menu-G2CF.png?v=1673927739"
                alt="">
        </div>
        <div class="wd-compare-detail-item-text">
        WD-G2CF
        </div>
        <div class="wd-compare-detail-item-text">
        CF-12 Mths
        </div>
    </a>
  </div>
  <div class="wd-compare-detail-item-a">
    <a href="https://www.waterdropfilter.com/products/wd-g2p6mro">
        <div class="wd-compare-detail-item-img">
            <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/ui-wd-g2pmro.png?v=1678343818"
                alt="">
        </div>
        <div class="wd-compare-detail-item-text">
        WD-G2P6MRO  
        </div>
        <div class="wd-compare-detail-item-text">
        P6MRO-24 Mths
        </div>
    </a>
  </div>`);

            $(".wd-compare-detail-average .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-text")
                .html(`$79.99`);

            $(".wd-compare-detail-filter_life .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-filter.svg?v=1682313834" alt="">`
                );

            $(".wd-compare-detail-tds .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-smart_none-svg.svg?v=1682313834" alt="">`
                );

            $(".wd-compare-detail-temperature .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    ` <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-smart_none-svg.svg?v=1682313834" alt="">`
                );

            $(".wd-compare-detail-uv .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-smart_none-svg.svg?v=1682313834" alt="">`
                );

            $(".wd-compare-detail-self .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-smart_none-svg.svg?v=1682313834" alt="">`
                );


            $(".wd-compare-detail-adjustable .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    ` <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-smart_none-svg.svg?v=1682313834" alt="">`
                );
            $(".wd-compare-detail-sound .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-sound-svg.svg?v=1682313834" alt="">`
                );
        } else if (title == "D6") {
            $(".wd-compare-header .wd-compare-header-item")
                .eq(wd_compare_index)
                .find(".wd-compare-header-item-img img")
                .attr(
                    "src",
                    "https://cdn.shopify.com/s/files/1/0078/6156/7570/files/ui-wd-d6-b-gpd.png"
                );
            $(".wd-compare-product .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-product-img img")
                .attr(
                    "src",
                    "https://cdn.shopify.com/s/files/1/0078/6156/7570/files/ui-wd-d6-b-gpd.png"
                );
            $(".wd-compare-product .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-product-shop a")
                .attr(
                    "href",
                    "https://www.waterdropfilter.com/products/ro-water-filter-system-d6"
                );
            $(".wd-compare-detail-pure .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-2_1-svg.svg?v=1682313834" alt="">`
                );
            $(".wd-compare-detail-flow_capacity .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-text")
                .html("600 GPD");
            $(".wd-compare-detail-flow_rate .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-text")
                .html("0.42 GPM");
            $(".wd-compare-detail-flow_rate .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg_text")
                .html(`<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-flow-svg.svg?v=1682313834" alt="">
  8s`);
            $(".wd-compare-detail-flow_rate .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-subtext-oz")
                .html(`*The capacity of the glass is 8oz`);
            $(".wd-compare-detail-water_capacity_options .wd-compare-detail-item")
                .eq(wd_compare_index)
                .html(
                    `<div class="wd-compare-detail-item-svg"><img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-water_capacity_none-svg.svg?v=1682313834" alt=""></div>`
                );
            $(".wd-compare-detail-dispensing_option .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .eq(0)
                .html(
                    ` <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dispensing-svg.svg?v=1682313834" alt="">`
                );
            $(".wd-compare-detail-dispensing_option .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .eq(1)
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dispensing_none-svg.svg?v=1682313835" alt="">`
                );
            $(".wd-compare-detail-dispensing_option .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .eq(2)
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dispensing_none-svg.svg?v=1682313835" alt="">`
                );
            $(".wd-compare-detail-water .wd-compare-detail-item")
                .eq(wd_compare_index)
                .html(
                    `<div class="wd-compare-detail-item-svg"><img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-water-tank_none.svg?v=1682315144" alt=""></div>`
                );
            $(".wd-compare-detail-installation .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`
      <div class="wd-compare-detail-item-svg">
      <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-installation-1-svg.svg?v=1682313834" alt="">
  </div>
  <div class="wd-compare-detail-item-subtext">
      Need Installation
  </div>
  <div class="wd-compare-detail-item-svg">
      <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-installation-2-svg.svg?v=1682313834" alt="">
  </div>
  <div class="wd-compare-detail-item-subtext">
      Drill a hole in the countertop
  </div>
    `);
            $(".wd-compare-detail-dimensions .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-text")
                .html(`15.98”*5.98”*11.97”`);
            $(".wd-compare-detail-item_weight .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-text")
                .html(`23.4lb`);
            $(".wd-compare-detail-warranty .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-text")
                .html(`1 Year`);
            $(".wd-compare-detail-usage_scenario .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-usage_scenario-svg1.svg?v=1682313834" alt="">`
                );
            $(".wd-compare-detail-usage_scenario .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-text")
                .html(`Undersink`);

            $(".wd-compare-detail-nsf .wd-compare-detail-item").eq(wd_compare_index)
                .html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835"
            alt="">
    </div>`);

            $(".wd-compare-detail-fcc .wd-compare-detail-item").eq(wd_compare_index)
                .html(`<div class="wd-compare-detail-item-img">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-page-icon-2.png?v=1681377284"
            alt="">
    </div>`);

            $(".wd-compare-detail-ce .wd-compare-detail-item").eq(wd_compare_index)
                .html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835"
            alt="">
    </div>`);

            $(".wd-compare-detail-reddot_design .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835"
            alt="">
    </div>`);

            $(".wd-compare-detail-sgs .wd-compare-detail-item").eq(wd_compare_index)
                .html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835"
            alt="">
    </div>`);

            $(".wd-compare-detail-tuv .wd-compare-detail-item").eq(wd_compare_index)
                .html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835" alt="">
    </div>`);

            $(".wd-compare-detail-ul .wd-compare-detail-item").eq(wd_compare_index)
                .html(` <div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835" alt="">
    </div>`);

            $(".wd-compare-detail-filtration .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-bigtext")
                .html(`6 Stages`);
            $(".wd-compare-detail-reduce .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-reduce_none-svg.svg?v=1682313834" alt="">
    </div>
    <div class="wd-compare-detail-item-longtext">
        TDS, PFAS, fluoride, chlorine, inorganic arsenic compounds, salts like nitrate and
        chloride, viruses, bacteria, and other harmful substances<br><br>
        Heavy metals: chromium, lead, arsenic, iron, radium, and calcium<br><br>
        Dirt, dust, sand, chlorine, taste and odor, colloid, residual large particles, suspended
        solids, rust, sediment, large particles,
        scale
    </div>
   `);

            $(".wd-compare-detail-filter_life_span .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`<div class="wd-compare-detail-item-a">
    <a href="https://www.waterdropfilter.com/collections/ro-system-replacement-filters/products/wd-d6rf">
        <div class="wd-compare-detail-item-img">
            <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/ui-wd-d6rf.png?v=1639380909"
                alt="">
        </div>
        <div class="wd-compare-detail-item-text">
        WD-D6RF
        </div>
        <div class="wd-compare-detail-item-text">
        12 Mths
        </div>
    </a>
  </div>`);

            $(".wd-compare-detail-average .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-text")
                .html(`$99.99`);

            $(".wd-compare-detail-filter_life .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-filter.svg?v=1682313834" alt="">`
                );

            $(".wd-compare-detail-tds .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-tds-svg.svg?v=1682313834" alt="">`
                );

            $(".wd-compare-detail-temperature .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    ` <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-smart_none-svg.svg?v=1682313834" alt="">`
                );

            $(".wd-compare-detail-uv .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-smart_none-svg.svg?v=1682313834" alt="">`
                );

            $(".wd-compare-detail-self .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-self-svg.svg?v=1682313834" alt="">`
                );


            $(".wd-compare-detail-adjustable .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    ` <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-smart_none-svg.svg?v=1682313834" alt="">`
                );
            $(".wd-compare-detail-sound .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-sound-svg.svg?v=1682313834" alt="">`
                );
        } else if (title == "G2") {
            $(".wd-compare-header .wd-compare-header-item")
                .eq(wd_compare_index)
                .find(".wd-compare-header-item-img img")
                .attr(
                    "src",
                    "https://cdn.shopify.com/s/files/1/0078/6156/7570/files/ui-wd-g2-w-new.png"
                );
            $(".wd-compare-product .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-product-img img")
                .attr(
                    "src",
                    "https://cdn.shopify.com/s/files/1/0078/6156/7570/files/ui-wd-g2-w-new.png"
                );
            $(".wd-compare-product .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-product-shop a")
                .attr(
                    "href",
                    "https://www.waterdropfilter.com/products/tankless-reverse-osmosis-system-g2"
                );
            $(".wd-compare-detail-pure .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-1_1-svg.svg?v=1682313834" alt="">`
                );
            $(".wd-compare-detail-flow_capacity .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-text")
                .html("400 GPD");
            $(".wd-compare-detail-flow_rate .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-text")
                .html("0.28 GPM");
            $(".wd-compare-detail-flow_rate .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg_text")
                .html(`<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-flow-svg.svg?v=1682313834" alt="">
  12s`);
            $(".wd-compare-detail-flow_rate .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-subtext-oz")
                .html(`*The capacity of the glass is 8oz`);
            $(".wd-compare-detail-water_capacity_options .wd-compare-detail-item")
                .eq(wd_compare_index)
                .html(
                    `<div class="wd-compare-detail-item-svg"><img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-water_capacity_none-svg.svg?v=1682313834" alt=""></div>`
                );
            $(".wd-compare-detail-dispensing_option .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .eq(0)
                .html(
                    ` <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dispensing-svg.svg?v=1682313834" alt="">`
                );
            $(".wd-compare-detail-dispensing_option .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .eq(1)
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dispensing_none-svg.svg?v=1682313835" alt="">`
                );
            $(".wd-compare-detail-dispensing_option .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .eq(2)
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dispensing_none-svg.svg?v=1682313835" alt="">`
                );
            $(".wd-compare-detail-water .wd-compare-detail-item")
                .eq(wd_compare_index)
                .html(
                    `<div class="wd-compare-detail-item-svg"><img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-water-tank_none.svg?v=1682315144" alt=""></div>`
                );
            $(".wd-compare-detail-installation .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`
      <div class="wd-compare-detail-item-svg">
      <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-installation-1-svg.svg?v=1682313834" alt="">
  </div>
  <div class="wd-compare-detail-item-subtext">
      Need Installation
  </div>
  <div class="wd-compare-detail-item-svg">
      <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-installation-2-svg.svg?v=1682313834" alt="">
  </div>
  <div class="wd-compare-detail-item-subtext">
      Drill a hole in the countertop
  </div>
    `);
            $(".wd-compare-detail-dimensions .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-text")
                .html(`17.7”*5.9”*13.9”`);
            $(".wd-compare-detail-item_weight .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-text")
                .html(`20.94lb`);
            $(".wd-compare-detail-warranty .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-text")
                .html(`1 Year`);
            $(".wd-compare-detail-usage_scenario .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-usage_scenario-svg1.svg?v=1682313834" alt="">`
                );
            $(".wd-compare-detail-usage_scenario .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-text")
                .html(`Undersink`);

            $(".wd-compare-detail-nsf .wd-compare-detail-item").eq(wd_compare_index)
                .html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835"
            alt="">
    </div>`);

            $(".wd-compare-detail-fcc .wd-compare-detail-item").eq(wd_compare_index)
                .html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835"
            alt="">
    </div>`);

            $(".wd-compare-detail-ce .wd-compare-detail-item").eq(wd_compare_index)
                .html(`<div class="wd-compare-detail-item-img">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-page-icon-3.png?v=1681377284"
            alt="">
    </div>`);

            $(".wd-compare-detail-reddot_design .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835"
            alt="">
    </div>`);

            $(".wd-compare-detail-sgs .wd-compare-detail-item").eq(wd_compare_index)
                .html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835"
            alt="">
    </div>`);

            $(".wd-compare-detail-tuv .wd-compare-detail-item").eq(wd_compare_index)
                .html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835" alt="">
    </div>`);

            $(".wd-compare-detail-ul .wd-compare-detail-item").eq(wd_compare_index)
                .html(` <div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835" alt="">
    </div>`);

            $(".wd-compare-detail-filtration .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-bigtext")
                .html(`7 Stages`);
            $(".wd-compare-detail-reduce .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-reduce_none-svg.svg?v=1682313834" alt="">
    </div>
  
    <div class="wd-compare-detail-item-longtext">
        TDS, PFAS, fluoride, chlorine, inorganic arsenic compounds, salts like nitrate and
        chloride, viruses, bacteria, and other harmful substances<br><br>
        Heavy metals: chromium, lead, arsenic, iron, radium, and calcium<br><br>
        Dirt, dust, sand, chlorine, taste and odor, colloid, residual large particles, suspended
        solids, rust, sediment, large particles,
        scale
    </div>`);

            $(".wd-compare-detail-filter_life_span .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`<div class="wd-compare-detail-item-a">
    <a href="https://www.waterdropfilter.com/products/wd-g2cf-filter-for-wd-g2-reverse-osmosis-system">
        <div class="wd-compare-detail-item-img">
            <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-product-menu-G2CF.png?v=1673927739"
                alt="">
        </div>
        <div class="wd-compare-detail-item-text">
        WD-G2CF
        </div>
        <div class="wd-compare-detail-item-text">
        CF-12 Mths
        </div>
    </a>
  </div>
  <div class="wd-compare-detail-item-a">
    <a href="https://www.waterdropfilter.com/products/wd-g2mro-filter-for-wd-g2-reverse-osmosis-system">
        <div class="wd-compare-detail-item-img">
            <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/ui-wd-g2mro-new.png?v=1678345102"
                alt="">
        </div>
        <div class="wd-compare-detail-item-text">
        WD-G2MRO
        </div>
        <div class="wd-compare-detail-item-text">
        MRO-24 Mths
        </div>
    </a>
  </div>`);

            $(".wd-compare-detail-average .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-text")
                .html(`$74.99`);

            $(".wd-compare-detail-filter_life .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-filter.svg?v=1682313834" alt="">`
                );

            $(".wd-compare-detail-tds .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-smart_none-svg.svg?v=1682313834" alt="">`
                );

            $(".wd-compare-detail-temperature .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    ` <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-smart_none-svg.svg?v=1682313834" alt="">`
                );

            $(".wd-compare-detail-uv .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-smart_none-svg.svg?v=1682313834" alt="">`
                );

            $(".wd-compare-detail-self .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-smart_none-svg.svg?v=1682313834" alt="">`
                );

            $(".wd-compare-detail-smart .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    ` <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-smart_none-svg.svg?v=1682313834" alt="">`
                );
            $(".wd-compare-detail-adjustable .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    ` <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-smart_none-svg.svg?v=1682313834" alt="">`
                );
            $(".wd-compare-detail-sound .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-sound-svg.svg?v=1682313834" alt="">`
                );
        } else if (title == "D4") {
            $(".wd-compare-header .wd-compare-header-item")
                .eq(wd_compare_index)
                .find(".wd-compare-header-item-img img")
                .attr(
                    "src",
                    "https://cdn.shopify.com/s/files/1/0078/6156/7570/files/ui-wd-d4-w-new.png"
                );
            $(".wd-compare-product .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-product-img img")
                .attr(
                    "src",
                    "https://cdn.shopify.com/s/files/1/0078/6156/7570/files/ui-wd-d4-w-new.png"
                );
            $(".wd-compare-product .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-product-shop a")
                .attr(
                    "href",
                    "https://www.waterdropfilter.com/products/reverse-osmosis-system-wd-d4-w"
                );
            $(".wd-compare-detail-pure .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-1_1-svg.svg?v=1682313834" alt="">`
                );
            $(".wd-compare-detail-flow_capacity .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-text")
                .html("400 GPD");
            $(".wd-compare-detail-flow_rate .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-text")
                .html("0.28 GPM");
            $(".wd-compare-detail-flow_rate .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg_text")
                .html(`<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-flow-svg.svg?v=1682313834" alt="">
  12s`);
            $(".wd-compare-detail-flow_rate .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-subtext-oz")
                .html(`*The capacity of the glass is 8oz`);
            $(".wd-compare-detail-water_capacity_options .wd-compare-detail-item")
                .eq(wd_compare_index)
                .html(
                    `<div class="wd-compare-detail-item-svg"><img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-water_capacity_none-svg.svg?v=1682313834" alt=""></div>`
                );
            $(".wd-compare-detail-dispensing_option .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .eq(0)
                .html(
                    ` <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dispensing-svg.svg?v=1682313834" alt="">`
                );
            $(".wd-compare-detail-dispensing_option .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .eq(1)
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dispensing_none-svg.svg?v=1682313835" alt="">`
                );
            $(".wd-compare-detail-dispensing_option .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .eq(2)
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dispensing_none-svg.svg?v=1682313835" alt="">`
                );
            $(".wd-compare-detail-water .wd-compare-detail-item")
                .eq(wd_compare_index)
                .html(
                    `<div class="wd-compare-detail-item-svg"><img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-water-tank_none.svg?v=1682315144" alt=""></div>`
                );
            $(".wd-compare-detail-installation .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`
      <div class="wd-compare-detail-item-svg">
      <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-installation-1-svg.svg?v=1682313834" alt="">
  </div>
  <div class="wd-compare-detail-item-subtext">
      Need Installation
  </div>
  <div class="wd-compare-detail-item-svg">
      <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-installation-2-svg.svg?v=1682313834" alt="">
  </div>
  <div class="wd-compare-detail-item-subtext">
      Drill a hole in the countertop
  </div>
    `);
            $(".wd-compare-detail-dimensions .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-text")
                .html(`16.02”*6.22”*12.44”`);
            $(".wd-compare-detail-item_weight .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-text")
                .html(`22.49lb`);
            $(".wd-compare-detail-warranty .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-text")
                .html(`1 Year`);
            $(".wd-compare-detail-usage_scenario .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-usage_scenario-svg1.svg?v=1682313834" alt="">`
                );
            $(".wd-compare-detail-usage_scenario .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-text")
                .html(`Undersink`);

            $(".wd-compare-detail-nsf .wd-compare-detail-item").eq(wd_compare_index)
                .html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835"
            alt="">
    </div>`);

            $(".wd-compare-detail-fcc .wd-compare-detail-item").eq(wd_compare_index)
                .html(`<div class="wd-compare-detail-item-img">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-page-icon-2.png?v=1681377284"
            alt="">
    </div>`);

            $(".wd-compare-detail-ce .wd-compare-detail-item").eq(wd_compare_index)
                .html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835"
            alt="">
    </div>`);

            $(".wd-compare-detail-reddot_design .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835"
            alt="">
    </div>`);

            $(".wd-compare-detail-sgs .wd-compare-detail-item").eq(wd_compare_index)
                .html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835"
            alt="">
    </div>`);

            $(".wd-compare-detail-tuv .wd-compare-detail-item").eq(wd_compare_index)
                .html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835" alt="">
    </div>`);

            $(".wd-compare-detail-ul .wd-compare-detail-item").eq(wd_compare_index)
                .html(` <div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835" alt="">
    </div>`);

            $(".wd-compare-detail-filtration .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-bigtext")
                .html(`6 Stages`);
            $(".wd-compare-detail-reduce .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-reduce_none-svg.svg?v=1682313834" alt="">
    </div>
    <div class="wd-compare-detail-item-longtext">
        TDS, PFAS, fluoride, chlorine, inorganic arsenic compounds, salts like nitrate and
        chloride, viruses, bacteria, and other harmful substances<br><br>
        Heavy metals: chromium, lead, arsenic, iron, radium, and calcium<br><br>
        Dirt, dust, sand, chlorine, taste and odor, colloid, residual large particles, suspended
        solids, rust, sediment, large particles,
        scale
    </div>`);

            $(".wd-compare-detail-filter_life_span .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`<div class="wd-compare-detail-item-a">
    <a href="https://www.waterdropfilter.com/products/wd-d4rf-1">
        <div class="wd-compare-detail-item-img">
            <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/products/wd-product-WD-D4-W-img1.png"
                alt="">
        </div>
        <div class="wd-compare-detail-item-text">
        WD-D4RF
        </div>
        <div class="wd-compare-detail-item-text">
        12 Mths
        </div>
    </a>
  </div>`);

            $(".wd-compare-detail-average .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-text")
                .html(`$99.99`);

            $(".wd-compare-detail-filter_life .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-filter.svg?v=1682313834" alt="">`
                );

            $(".wd-compare-detail-tds .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-smart_none-svg.svg?v=1682313834" alt="">`
                );

            $(".wd-compare-detail-temperature .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    ` <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-smart_none-svg.svg?v=1682313834" alt="">`
                );

            $(".wd-compare-detail-uv .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-smart_none-svg.svg?v=1682313834" alt="">`
                );

            $(".wd-compare-detail-self .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-self-svg.svg?v=1682313834" alt="">`
                );

            $(".wd-compare-detail-smart .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    ` <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-smart_none-svg.svg?v=1682313834" alt="">`
                );
            $(".wd-compare-detail-adjustable .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    ` <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-smart_none-svg.svg?v=1682313834" alt="">`
                );
            $(".wd-compare-detail-sound .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-sound-svg.svg?v=1682313834" alt="">`
                );
        } else if (title == "A1") {
            $(".wd-compare-header .wd-compare-header-item")
                .eq(wd_compare_index)
                .find(".wd-compare-header-item-img img")
                .attr(
                    "src",
                    "https://cdn.shopify.com/s/files/1/0078/6156/7570/files/ui-wd-a1-new.png?v=1687661943"
                );
            $(".wd-compare-product .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-product-img img")
                .attr(
                    "src",
                    "https://cdn.shopify.com/s/files/1/0078/6156/7570/files/ui-wd-a1-new.png?v=1687661943"
                );
            $(".wd-compare-product .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-product-shop a")
                .attr(
                    "href",
                    "https://www.waterdropfilter.com/products/ro-hot-cold-water-dispenser-a1"
                );
            $(".wd-compare-detail-pure .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-2_1-svg.svg?v=1682313834" alt="">`
                );
            $(".wd-compare-detail-flow_capacity .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-text")
                .html("100 GPD");
            $(".wd-compare-detail-flow_rate .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-text")
                .html("0.07 GPM");
            $(".wd-compare-detail-flow_rate .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg_text").html(`
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-flow_none-svg.svg?v=1682313834" alt="">`);
            $(".wd-compare-detail-flow_rate .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-subtext-oz")
                .html(`*The capacity of the glass is 8oz`);
            $(".wd-compare-detail-water_capacity_options .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`<div class="wd-compare-detail-item-blacktext">5-mode </div>
        <div class="wd-compare-detail-item-subtext">Customizable Water Capacity</div>`);
            $(".wd-compare-detail-dispensing_option .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .eq(0)
                .html(
                    ` <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dispensing-svg.svg?v=1682313834" alt="">`
                );
            $(".wd-compare-detail-dispensing_option .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .eq(1)
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dispensing-svg.svg?v=1682313834" alt="">`
                );
            $(".wd-compare-detail-dispensing_option .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .eq(2)
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dispensing-svg.svg?v=1682313834" alt="">`
                );
            $(".wd-compare-detail-water .wd-compare-detail-item")
                .eq(wd_compare_index)
                .html(`<div class="wd-compare-detail-item-text">204 oz</div>`);
            $(".wd-compare-detail-installation .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`
      <div class="wd-compare-detail-item-svg">
      <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-installation-1-none-svg.svg?v=1682313834" alt="">
  </div>
  <div class="wd-compare-detail-item-subtext">
  No Installation
  </div>
  <div class="wd-compare-detail-item-svg">
      <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-installation-2-none-svg.svg?v=1682313835" alt="">
  </div>
  <div class="wd-compare-detail-item-subtext">
      Drill a hole in the countertop
  </div>
    `);
            $(".wd-compare-detail-dimensions .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-text")
                .html(`18.3” *7.8” *17.1”`);
            $(".wd-compare-detail-item_weight .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-text")
                .html(`38.58lb`);
            $(".wd-compare-detail-warranty .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-text")
                .html(`1 Year`);
            $(".wd-compare-detail-usage_scenario .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-usage_scenario-svg2.svg?v=1682313835" alt="">`
                );
            $(".wd-compare-detail-usage_scenario .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-text")
                .html(`Countertop`);

            $(".wd-compare-detail-nsf .wd-compare-detail-item").eq(wd_compare_index)
                .html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-page-icon-8.png?v=1685341817"
            alt="">
    </div>`);

            $(".wd-compare-detail-fcc .wd-compare-detail-item").eq(wd_compare_index)
                .html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835"
            alt="">
    </div>`);

            $(".wd-compare-detail-ce .wd-compare-detail-item").eq(wd_compare_index)
                .html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835"
            alt="">
    </div>`);

            $(".wd-compare-detail-reddot_design .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835"
            alt="">
    </div>`);

            $(".wd-compare-detail-sgs .wd-compare-detail-item").eq(wd_compare_index)
                .html(`<div class="wd-compare-detail-item-img">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-page-icon-5.png?v=1681377284"
            alt="">
    </div>`);

            $(".wd-compare-detail-tuv .wd-compare-detail-item").eq(wd_compare_index)
                .html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835" alt="">
    </div>`);

            $(".wd-compare-detail-ul .wd-compare-detail-item").eq(wd_compare_index)
                .html(` <div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835" alt="">
    </div>`);

            $(".wd-compare-detail-filtration .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-bigtext")
                .html(`6 Stages`);
            $(".wd-compare-detail-reduce .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-reduce-svg.svg?v=1682313834" alt="">
    </div>
    <div class="wd-compare-detail-item-text">
        99.9% UV Sterilization Rate
    </div>
    <div class="wd-compare-detail-item-longtext">
        TDS, PFAS, fluoride, chlorine, inorganic arsenic compounds, salts like nitrate and
        chloride, viruses, bacteria, and other harmful substances<br><br>
        Heavy metals: chromium, lead, arsenic, iron, radium, and calcium<br><br>
        Dirt, dust, sand, chlorine, taste and odor, colloid, residual large particles, suspended
        solids, rust, sediment, large particles,
        scale
    </div>
    <div class="wd-compare-detail-item-a">
        <a href="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/WD-A1-NSF-ANSI-372-certification.pdf?v=1688981708">View
        the report &gt;</a>
    </div>
  `);

            $(".wd-compare-detail-filter_life_span .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`<div class="wd-compare-detail-item-a">
    <a href="https://www.waterdropfilter.com/products/replacement-for-a1-countertop-ro-system-wd-a1-cf">
        <div class="wd-compare-detail-item-img">
            <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/ui-wd-a1-cf.png?v=1687763853WD-A1-RO:https://cdn.shopify.com/s/files/1/0078/6156/7570/files/ui-wd-a1-ro.png?v=1687763853"
                alt="">
        </div>
        <div class="wd-compare-detail-item-text">
        WD-A1-CF
        </div>
        <div class="wd-compare-detail-item-text">
        CF-6 Mths
        </div>
    </a>
  </div>
  <div class="wd-compare-detail-item-a">
    <a href="https://www.waterdropfilter.com/products/replacement-for-a1-countertop-ro-system-wd-a1-ro">
        <div class="wd-compare-detail-item-img">
            <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/ui-wd-a1-ro.png?v=1687763853"
                alt="">
        </div>
        <div class="wd-compare-detail-item-text">
        WD-A1-RO
        </div>
        <div class="wd-compare-detail-item-text">
        RO-12 Mths
        </div>
    </a>
  </div>`);

            $(".wd-compare-detail-average .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-text")
                .html(`$129.97`);

            $(".wd-compare-detail-filter_life .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-filter.svg?v=1682313834" alt="">`
                );

            $(".wd-compare-detail-tds .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-tds-svg.svg?v=1682313834" alt="">`
                );

            $(".wd-compare-detail-temperature .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    ` <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-temperature-svg.svg?v=1682313834" alt="">`
                );

            $(".wd-compare-detail-uv .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-uv-svg.svg?v=1682313835" alt="">`
                );

            $(".wd-compare-detail-self .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-self-svg.svg?v=1682313834" alt="">`
                );


            $(".wd-compare-detail-adjustable .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    ` <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-smart_none-svg.svg?v=1682313834" alt="">`
                );
            $(".wd-compare-detail-sound .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-sound-svg.svg?v=1682313834" alt="">`
                );
        } else if (title == "K19-S") {
            $(".wd-compare-header .wd-compare-header-item")
                .eq(wd_compare_index)
                .find(".wd-compare-header-item-img img")
                .attr(
                    "src",
                    "https://cdn.shopify.com/s/files/1/0078/6156/7570/files/ui-wd-k19-s.png"
                );
            $(".wd-compare-product .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-product-img img")
                .attr(
                    "src",
                    "https://cdn.shopify.com/s/files/1/0078/6156/7570/files/ui-wd-k19-s.png"
                );
            $(".wd-compare-product .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-product-shop a")
                .attr(
                    "href",
                    "https://www.waterdropfilter.com/products/countertop-ro-water-filter-system-wd-k19-s"
                );
            $(".wd-compare-detail-pure .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-3_1-svg.svg?v=1682313834" alt="">`
                );
            $(".wd-compare-detail-flow_capacity .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-text")
                .html("75 GPD");
            $(".wd-compare-detail-flow_rate .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-text")
                .html("0.05 GPM");
            $(".wd-compare-detail-flow_rate .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg_text").html(`
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-flow_none-svg.svg?v=1682313834" alt="">`);
            $(".wd-compare-detail-flow_rate .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-subtext-oz")
                .html(`*The capacity of the glass is 8oz`);
            $(".wd-compare-detail-water_capacity_options .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`<div class="wd-compare-detail-item-blacktext">4-mode </div>
        <div class="wd-compare-detail-item-subtext">Customizable Water Capacity</div>`);
            $(".wd-compare-detail-dispensing_option .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .eq(0)
                .html(
                    ` <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dispensing-svg.svg?v=1682313834" alt="">`
                );
            $(".wd-compare-detail-dispensing_option .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .eq(1)
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dispensing_none-svg.svg?v=1682313835" alt="">`
                );
            $(".wd-compare-detail-dispensing_option .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .eq(2)
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dispensing_none-svg.svg?v=1682313835" alt="">`
                );
            $(".wd-compare-detail-water .wd-compare-detail-item")
                .eq(wd_compare_index)
                .html(`<div class="wd-compare-detail-item-text">170 oz</div>`);
            $(".wd-compare-detail-installation .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`
      <div class="wd-compare-detail-item-svg">
      <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-installation-1-none-svg.svg?v=1682313834" alt="">
  </div>
  <div class="wd-compare-detail-item-subtext">
      No Installation
  </div>
  <div class="wd-compare-detail-item-svg">
      <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-installation-2-none-svg.svg?v=1682313835" alt="">
  </div>
  <div class="wd-compare-detail-item-subtext">
      Drill a hole in the countertop
  </div>
    `);
            $(".wd-compare-detail-dimensions .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-text")
                .html(`15.51" *9.2”*17.56"`);
            $(".wd-compare-detail-item_weight .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-text")
                .html(`16.3lb`);
            $(".wd-compare-detail-warranty .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-text")
                .html(`1 Year`);
            $(".wd-compare-detail-usage_scenario .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-usage_scenario-svg2.svg?v=1682313835" alt="">`
                );
            $(".wd-compare-detail-usage_scenario .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-text")
                .html(`Countertop`);

            $(".wd-compare-detail-nsf .wd-compare-detail-item").eq(wd_compare_index)
                .html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835"
            alt="">
    </div>`);

            $(".wd-compare-detail-fcc .wd-compare-detail-item").eq(wd_compare_index)
                .html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835"
            alt="">
    </div>`);

            $(".wd-compare-detail-ce .wd-compare-detail-item").eq(wd_compare_index)
                .html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835"
            alt="">
    </div>`);

            $(".wd-compare-detail-reddot_design .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835"
            alt="">
    </div>`);

            $(".wd-compare-detail-sgs .wd-compare-detail-item").eq(wd_compare_index)
                .html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835"
            alt="">
    </div>`);

            $(".wd-compare-detail-tuv .wd-compare-detail-item").eq(wd_compare_index)
                .html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835" alt="">
    </div>`);

            $(".wd-compare-detail-ul .wd-compare-detail-item").eq(wd_compare_index)
                .html(` <div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835" alt="">
    </div>`);

            $(".wd-compare-detail-filtration .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-bigtext")
                .html(`6 Stages`);
            $(".wd-compare-detail-reduce .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-reduce-svg.svg?v=1682313834" alt="">
    </div>
    <div class="wd-compare-detail-item-text">
        99.9% UV Sterilization Rate
    </div>
    <div class="wd-compare-detail-item-longtext">
        TDS, PFAS, fluoride, chlorine, inorganic arsenic compounds, salts like nitrate and
        chloride, viruses, bacteria, and other harmful substances<br><br>
        Heavy metals: chromium, lead, arsenic, iron, radium, and calcium<br><br>
        Dirt, dust, sand, chlorine, taste and odor, colloid, residual large particles, suspended
        solids, rust, sediment, large particles,
        scale
    </div>
  `);

            $(".wd-compare-detail-filter_life_span .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`<div class="wd-compare-detail-item-a">
    <a href="https://www.waterdropfilter.com/products/replacement-for-k19-countertop-ro-system-wd-k19rf">
        <div class="wd-compare-detail-item-img">
            <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/ui-wd-k19rf.png?v=1678343818"
                alt="">
        </div>
        <div class="wd-compare-detail-item-text">
        WD-K19RF
        </div>
        <div class="wd-compare-detail-item-text">
        12 Mths
        </div>
    </a>
  </div>`);

            $(".wd-compare-detail-average .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-text")
                .html(`$75.00`);

            $(".wd-compare-detail-filter_life .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-filter.svg?v=1682313834" alt="">`
                );

            $(".wd-compare-detail-tds .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-tds-svg.svg?v=1682313834" alt="">`
                );

            $(".wd-compare-detail-temperature .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    ` <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-smart_none-svg.svg?v=1682313834" alt="">`
                );

            $(".wd-compare-detail-uv .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-uv-svg.svg?v=1682313835" alt="">`
                );

            $(".wd-compare-detail-self .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-self-svg.svg?v=1682313834" alt="">`
                );


            $(".wd-compare-detail-adjustable .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    ` <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-smart_none-svg.svg?v=1682313834" alt="">`
                );
            $(".wd-compare-detail-sound .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-sound-svg.svg?v=1682313834" alt="">`
                );
        } else if (title == "K19-H") {
            $(".wd-compare-header .wd-compare-header-item")
                .eq(wd_compare_index)
                .find(".wd-compare-header-item-img img")
                .attr(
                    "src",
                    "https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-product-page-k19-compare-img2-new.png"
                );
            $(".wd-compare-product .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-product-img img")
                .attr(
                    "src",
                    "https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-product-page-k19-compare-img2-new.png"
                );
            $(".wd-compare-product .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-product-shop a")
                .attr(
                    "href",
                    "https://www.waterdropfilter.com/products/countertop-ro-system-instant-hot-k19"
                );
            $(".wd-compare-detail-pure .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-3_1-svg.svg?v=1682313834" alt="">`
                );
            $(".wd-compare-detail-flow_capacity .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-text")
                .html("75 GPD");
            $(".wd-compare-detail-flow_rate .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-text")
                .html("0.05 GPM");
            $(".wd-compare-detail-flow_rate .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg_text")
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-flow_none-svg.svg?v=1682313834" alt="">`
                );
            $(".wd-compare-detail-flow_rate .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-subtext-oz")
                .html(`*The capacity of the glass is 8oz`);
            $(".wd-compare-detail-water_capacity_options .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`<div class="wd-compare-detail-item-blacktext">5-mode </div>
  <div class="wd-compare-detail-item-subtext">Customizable Water Capacity</div>`);
            $(".wd-compare-detail-dispensing_option .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .eq(0)
                .html(
                    ` <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dispensing-svg.svg?v=1682313834" alt="">`
                );
            $(".wd-compare-detail-dispensing_option .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .eq(1)
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dispensing-svg.svg?v=1682313834" alt="">`
                );
            $(".wd-compare-detail-dispensing_option .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .eq(2)
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dispensing_none-svg.svg?v=1682313835" alt="">`
                );
            $(".wd-compare-detail-water .wd-compare-detail-item")
                .eq(wd_compare_index)
                .html(`<div class="wd-compare-detail-item-text">170 oz</div>`);
            $(".wd-compare-detail-installation .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`
      <div class="wd-compare-detail-item-svg">
      <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-installation-1-none-svg.svg?v=1682313834" alt="">
  </div>
  <div class="wd-compare-detail-item-subtext">
      No Installation
  </div>
  <div class="wd-compare-detail-item-svg">
      <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-installation-2-none-svg.svg?v=1682313835" alt="">
  </div>
  <div class="wd-compare-detail-item-subtext">
      Drill a hole in the countertop
  </div>
    `);
            $(".wd-compare-detail-dimensions .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-text")
                .html(`15.51" *9.2”*17.56"`);
            $(".wd-compare-detail-item_weight .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-text")
                .html(`16.3lb`);
            $(".wd-compare-detail-warranty .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-text")
                .html(`1 Year`);
            $(".wd-compare-detail-usage_scenario .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-usage_scenario-svg2.svg?v=1682313835" alt="">`
                );
            $(".wd-compare-detail-usage_scenario .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-text")
                .html(`Countertop`);

            $(".wd-compare-detail-nsf .wd-compare-detail-item").eq(wd_compare_index)
                .html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835"
            alt="">
    </div>`);

            $(".wd-compare-detail-fcc .wd-compare-detail-item").eq(wd_compare_index)
                .html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835"
            alt="">
    </div>`);

            $(".wd-compare-detail-ce .wd-compare-detail-item").eq(wd_compare_index)
                .html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835"
            alt="">
    </div>`);

            $(".wd-compare-detail-reddot_design .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835"
            alt="">
    </div>`);

            $(".wd-compare-detail-sgs .wd-compare-detail-item").eq(wd_compare_index)
                .html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835"
            alt="">
    </div>`);

            $(".wd-compare-detail-tuv .wd-compare-detail-item").eq(wd_compare_index)
                .html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835" alt="">
    </div>`);

            $(".wd-compare-detail-ul .wd-compare-detail-item").eq(wd_compare_index)
                .html(` <div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835" alt="">
    </div>`);

            $(".wd-compare-detail-filtration .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-bigtext")
                .html(`6 Stages`);
            $(".wd-compare-detail-reduce .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-reduce-svg.svg?v=1682313834" alt="">
    </div>
    <div class="wd-compare-detail-item-text">
        99.9% UV Sterilization Rate
    </div>
    <div class="wd-compare-detail-item-longtext">
        TDS, PFAS, fluoride, chlorine, inorganic arsenic compounds, salts like nitrate and
        chloride, viruses, bacteria, and other harmful substances<br><br>
        Heavy metals: chromium, lead, arsenic, iron, radium, and calcium<br><br>
        Dirt, dust, sand, chlorine, taste and odor, colloid, residual large particles, suspended
        solids, rust, sediment, large particles,
        scale
    </div>`);

            $(".wd-compare-detail-filter_life_span .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`<div class="wd-compare-detail-item-a">
    <a href="https://www.waterdropfilter.com/products/replacement-for-k19-countertop-ro-system-wd-k19rf">
        <div class="wd-compare-detail-item-img">
            <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/ui-wd-k19rf.png?v=1678343818"
                alt="">
        </div>
        <div class="wd-compare-detail-item-text">
        WD-K19RF
        </div>
        <div class="wd-compare-detail-item-text">
        12 Mths
        </div>
    </a>
  </div>
  `);

            $(".wd-compare-detail-average .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-text")
                .html(`$75.00`);

            $(".wd-compare-detail-filter_life .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-filter.svg?v=1682313834" alt="">`
                );

            $(".wd-compare-detail-tds .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-tds-svg.svg?v=1682313834" alt="">`
                );

            $(".wd-compare-detail-temperature .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    ` <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-temperature-svg.svg?v=1682313834" alt="">`
                );

            $(".wd-compare-detail-uv .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-uv-svg.svg?v=1682313835" alt="">`
                );

            $(".wd-compare-detail-self .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-self-svg.svg?v=1682313834" alt="">`
                );


            $(".wd-compare-detail-adjustable .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    ` <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-smart_none-svg.svg?v=1682313834" alt="">`
                );
            $(".wd-compare-detail-sound .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-sound-svg.svg?v=1682313834" alt="">`
                );
        } else if (title == "N1-W") {
            $(".wd-compare-header .wd-compare-header-item")
                .eq(wd_compare_index)
                .find(".wd-compare-header-item-img img")
                .attr(
                    "src",
                    "https://cdn.shopify.com/s/files/1/0078/6156/7570/files/ui-wd-n1-w.png"
                );
            $(".wd-compare-product .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-product-img img")
                .attr(
                    "src",
                    "https://cdn.shopify.com/s/files/1/0078/6156/7570/files/ui-wd-n1-w.png"
                );
            $(".wd-compare-product .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-product-shop a")
                .attr(
                    "href",
                    "https://www.waterdropfilter.com/pages/countertop-reverse-osmosis-system-with-uv-sterilize-wd-n1-w"
                );
            $(".wd-compare-detail-pure .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-3_1-svg.svg?v=1682313834" alt="">`
                );
            $(".wd-compare-detail-flow_capacity .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-text")
                .html("75 GPD");
            $(".wd-compare-detail-flow_rate .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-text")
                .html("0.05 GPM");
            $(".wd-compare-detail-flow_rate .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg_text")
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-flow_none-svg.svg?v=1682313834" alt="">`
                );
            $(".wd-compare-detail-flow_rate .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-subtext-oz")
                .html(`*The capacity of the glass is 8oz`);
            $(".wd-compare-detail-water_capacity_options .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`<div class="wd-compare-detail-item-blacktext">4-mode </div>
        <div class="wd-compare-detail-item-subtext">Customizable Water Capacity</div>`);
            $(".wd-compare-detail-dispensing_option .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .eq(0)
                .html(
                    ` <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dispensing-svg.svg?v=1682313834" alt="">`
                );
            $(".wd-compare-detail-dispensing_option .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .eq(1)
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dispensing_none-svg.svg?v=1682313835" alt="">`
                );
            $(".wd-compare-detail-dispensing_option .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .eq(2)
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dispensing_none-svg.svg?v=1682313835" alt="">`
                );
            $(".wd-compare-detail-water .wd-compare-detail-item")
                .eq(wd_compare_index)
                .html(`<div class="wd-compare-detail-item-text">135 oz</div>`);
            $(".wd-compare-detail-installation .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`
      <div class="wd-compare-detail-item-svg">
      <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-installation-1-none-svg.svg?v=1682313834" alt="">
  </div>
  <div class="wd-compare-detail-item-subtext">
      No Installation
  </div>
  <div class="wd-compare-detail-item-svg">
      <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-installation-2-none-svg.svg?v=1682313835" alt="">
  </div>
  <div class="wd-compare-detail-item-subtext">
      Drill a hole in the countertop
  </div>
    `);
            $(".wd-compare-detail-dimensions .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-text")
                .html(`17.1" *7.0”*17.8"`);
            $(".wd-compare-detail-item_weight .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-text")
                .html(`19.4lb`);
            $(".wd-compare-detail-warranty .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-text")
                .html(`1 Year`);
            $(".wd-compare-detail-usage_scenario .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-usage_scenario-svg2.svg?v=1682313835" alt="">`
                );
            $(".wd-compare-detail-usage_scenario .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-text")
                .html(`Countertop`);

            $(".wd-compare-detail-nsf .wd-compare-detail-item").eq(wd_compare_index)
                .html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835"
            alt="">
    </div>`);

            $(".wd-compare-detail-fcc .wd-compare-detail-item").eq(wd_compare_index)
                .html(`<div class="wd-compare-detail-item-img">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-page-icon-2.png?v=1681377284"
            alt="">
    </div>`);

            $(".wd-compare-detail-ce .wd-compare-detail-item").eq(wd_compare_index)
                .html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835"
            alt="">
    </div>`);

            $(".wd-compare-detail-reddot_design .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`<div class="wd-compare-detail-item-img">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-page-icon-4.png?v=1681377284"
            alt="">
    </div>`);

            $(".wd-compare-detail-sgs .wd-compare-detail-item").eq(wd_compare_index)
                .html(`<div class="wd-compare-detail-item-img">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-page-icon-5.png?v=1681377284"
            alt="">
    </div>`);

            $(".wd-compare-detail-tuv .wd-compare-detail-item").eq(wd_compare_index)
                .html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835" alt="">
    </div>`);

            $(".wd-compare-detail-ul .wd-compare-detail-item").eq(wd_compare_index)
                .html(` <div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835" alt="">
    </div>`);

            $(".wd-compare-detail-filtration .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-bigtext")
                .html(`4 Stages`);
            $(".wd-compare-detail-reduce .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-reduce-svg.svg?v=1682313834" alt="">
    </div>
    <div class="wd-compare-detail-item-text">
        99.9% UV Sterilization Rate
    </div>
    <div class="wd-compare-detail-item-longtext">
        TDS, PFAS, fluoride, chlorine, inorganic arsenic compounds, salts like nitrate and
        chloride, viruses, bacteria, and other harmful substances<br><br>
        Heavy metals: chromium, lead, arsenic, iron, radium, and calcium<br><br>
        Dirt, dust, sand, chlorine, taste and odor, colloid, residual large particles, suspended
        solids, rust, sediment, large particles,
        scale
    </div>
    <div class="wd-compare-detail-item-a">
        <a
            href="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/Specification_Sheet_for_Reducing_Harmful_Substances-WD-N1-W.pdf?v=1677668629">View
            the report ></a>
    </div>`);

            $(".wd-compare-detail-filter_life_span .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`<div class="wd-compare-detail-item-a">
    <a href="https://www.waterdropfilter.com/products/wd-n1-cf">
        <div class="wd-compare-detail-item-img">
            <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/ui-wd-n1-cf-new.png?v=1678344316"
                alt="">
        </div>
        <div class="wd-compare-detail-item-text">
        WD-N1-CF
        </div>
        <div class="wd-compare-detail-item-text">
        CF-6 Mths
        </div>
    </a>
  </div>
  <div class="wd-compare-detail-item-a">
    <a href="https://www.waterdropfilter.com/products/wd-n1-mro">
        <div class="wd-compare-detail-item-img">
            <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/ui-wd-n1-mro-new.png?v=1678344316"
                alt="">
        </div>
        <div class="wd-compare-detail-item-text">
        WD-N1-MRO
        </div>
        <div class="wd-compare-detail-item-text">
        MRO-18 Mths
        </div>
    </a>
  </div>`);

            $(".wd-compare-detail-average .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-text")
                .html(`$106.65`);

            $(".wd-compare-detail-filter_life .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-filter.svg?v=1682313834" alt="">`
                );

            $(".wd-compare-detail-tds .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-tds-svg.svg?v=1682313834" alt="">`
                );

            $(".wd-compare-detail-temperature .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    ` <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-smart_none-svg.svg?v=1682313834" alt="">`
                );

            $(".wd-compare-detail-uv .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-uv-svg.svg?v=1682313835" alt="">`
                );

            $(".wd-compare-detail-self .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-self-svg.svg?v=1682313834" alt="">`
                );


            $(".wd-compare-detail-adjustable .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    ` <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-smart_none-svg.svg?v=1682313834" alt="">`
                );
            $(".wd-compare-detail-sound .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-sound-svg.svg?v=1682313834" alt="">`
                );
        } else if (title == "C1S") {
            $(".wd-compare-header .wd-compare-header-item")
                .eq(wd_compare_index)
                .find(".wd-compare-header-item-img img")
                .attr(
                    "src",
                    "https://cdn.shopify.com/s/files/1/0078/6156/7570/files/C1S_ba247b16-a430-4b1b-85de-d158678b6ac3.png?v=1704364980"
                );
            $(".wd-compare-product .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-product-img img")
                .attr(
                    "src",
                    "https://cdn.shopify.com/s/files/1/0078/6156/7570/files/C1S_ba247b16-a430-4b1b-85de-d158678b6ac3.png?v=1704364980"
                );
            $(".wd-compare-product .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-product-shop a")
                .attr(
                    "href",
                    "https://www.waterdropfilter.com/products/countertop-ro-system-corero-system-c1s"
                );
            $(".wd-compare-detail-pure .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-3_1-svg.svg?v=1682313834" alt="">`
                );
            $(".wd-compare-detail-flow_capacity .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-text")
                .html("75 GPD");
            $(".wd-compare-detail-flow_rate .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-text")
                .html("0.05 GPM");
            $(".wd-compare-detail-flow_rate .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg_text")
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-flow_none-svg.svg?v=1682313834" alt="">`
                );
            $(".wd-compare-detail-flow_rate .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-subtext-oz")
                .html(`*The capacity of the glass is 8oz`);
            $(".wd-compare-detail-water_capacity_options .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`<div class="wd-compare-detail-item-blacktext">5-mode</div>
        <div class="wd-compare-detail-item-subtext">Customizable Water
        Capacity</div>`);
            $(".wd-compare-detail-dispensing_option .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .eq(0)
                .html(
                    ` <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dispensing-svg.svg?v=1682313834" alt="">`
                );
            $(".wd-compare-detail-dispensing_option .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .eq(1)
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dispensing_none-svg.svg?v=1682313835" alt="">`
                );
            $(".wd-compare-detail-dispensing_option .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .eq(2)
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dispensing_none-svg.svg?v=1682313835" alt="">`
                );
            $(".wd-compare-detail-water .wd-compare-detail-item")
                .eq(wd_compare_index)
                .html(`<div class="wd-compare-detail-item-text">110 oz</div>`);
            $(".wd-compare-detail-installation .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`
      <div class="wd-compare-detail-item-svg">
      <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-installation-1-none-svg.svg?v=1682313834" alt="">
  </div>
  <div class="wd-compare-detail-item-subtext">
      No Installation
  </div>
  <div class="wd-compare-detail-item-svg">
      <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-installation-2-none-svg.svg?v=1682313835" alt="">
  </div>
  <div class="wd-compare-detail-item-subtext">
      Drill a hole in the countertop
  </div>
    `);
            $(".wd-compare-detail-dimensions .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-text")
                .html(`15.6" *10.9" *17.0"`);
            $(".wd-compare-detail-item_weight .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-text")
                .html(`14lb`);
            $(".wd-compare-detail-warranty .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-text")
                .html(`1 Year`);
            $(".wd-compare-detail-usage_scenario .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-usage_scenario-svg2.svg?v=1682313835" alt="">`
                );
            $(".wd-compare-detail-usage_scenario .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-text")
                .html(`Countertop`);

            $(".wd-compare-detail-nsf .wd-compare-detail-item").eq(wd_compare_index)
                .html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835"
            alt="">
    </div>`);

            $(".wd-compare-detail-fcc .wd-compare-detail-item").eq(wd_compare_index)
                .html(`<div class="wd-compare-detail-item-img">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-page-icon-2.png?v=1681377284"
            alt="">
    </div>`);

            $(".wd-compare-detail-ce .wd-compare-detail-item").eq(wd_compare_index)
                .html(`<div class="wd-compare-detail-item-img">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-page-icon-3.png?v=1681377284"
            alt="">
    </div>`);

            $(".wd-compare-detail-reddot_design .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835"
            alt="">
    </div>`);

            $(".wd-compare-detail-sgs .wd-compare-detail-item").eq(wd_compare_index)
                .html(`<div class="wd-compare-detail-item-img">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-page-icon-5.png?v=1681377284"
            alt="">
    </div>`);

            $(".wd-compare-detail-tuv .wd-compare-detail-item").eq(wd_compare_index)
                .html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835" alt="">
    </div>`);

            $(".wd-compare-detail-ul .wd-compare-detail-item").eq(wd_compare_index)
                .html(` <div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835" alt="">
    </div>`);

            $(".wd-compare-detail-filtration .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-bigtext")
                .html(`6 Stages`);
            $(".wd-compare-detail-reduce .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`
    <div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-reduce_none-svg.svg?v=1682313834" alt="">
    </div>
    <div class="wd-compare-detail-item-longtext">
    TDS,  PFAS, fluoride, chlorine, inorganic arsenic compounds, salts like nitrate and chloride, viruses, bacteria, and other harmful substances <br><br>
    Heavy metals: chromium, lead, arsenic, iron, radium, and calcium<br><br>
    Dirt, dust, sand, chlorine, taste and odor, colloid, residual large particles, suspended solids, rust, sediment, large particles, scale
    </div>`);

            $(".wd-compare-detail-filter_life_span .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`<div class="wd-compare-detail-item-a">
    <a href="https://www.waterdropfilter.com/products/countertop-ro-system-core-system-replacement-filter-c1rf">
        <div class="wd-compare-detail-item-img">
            <img src="https://cdn.shopifycdn.net/s/files/1/0078/6156/7570/files/3_28b6e831-a774-4147-b8c4-498d79867287.jpg?v=1704268955"
                alt="">
        </div>
        <div class="wd-compare-detail-item-text">
        WD-C1RF
        </div>
        <div class="wd-compare-detail-item-text">
        12 Mths
        </div>
    </a>
  </div>`);

            $(".wd-compare-detail-average .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-text")
                .html(`$59.00`);

            $(".wd-compare-detail-filter_life .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-filter.svg?v=1682313834" alt="">`
                );

            $(".wd-compare-detail-tds .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-tds-svg.svg?v=1682313834" alt="">`
                );

            $(".wd-compare-detail-temperature .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    ` <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-smart_none-svg.svg?v=1682313834" alt="">`
                );

            $(".wd-compare-detail-uv .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-smart_none-svg.svg?v=1682313834" alt="">`
                );

            $(".wd-compare-detail-self .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-self-svg.svg?v=1682313834" alt="">`
                );


            $(".wd-compare-detail-adjustable .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    ` <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-smart_none-svg.svg?v=1682313834" alt="">`
                );
            $(".wd-compare-detail-sound .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-sound-svg.svg?v=1682313834" alt="">`
                );
        } else if (title == "C1H") {
            $(".wd-compare-header .wd-compare-header-item")
                .eq(wd_compare_index)
                .find(".wd-compare-header-item-img img")
                .attr(
                    "src",
                    "https://cdn.shopify.com/s/files/1/0078/6156/7570/files/C1-Hot_72afa440-7950-454d-8945-74df049664d3.png?v=1704394767"
                );
            $(".wd-compare-product .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-product-img img")
                .attr(
                    "src",
                    "https://cdn.shopify.com/s/files/1/0078/6156/7570/files/C1-Hot_72afa440-7950-454d-8945-74df049664d3.png?v=1704394767"
                );
            $(".wd-compare-product .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-product-shop a")
                .attr(
                    "href",
                    "https://www.waterdropfilter.com/products/countertop-instant-hot-ro-system-corero-system-c1h"
                );
            $(".wd-compare-detail-pure .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-3_1-svg.svg?v=1682313834" alt="">`
                );
            $(".wd-compare-detail-flow_capacity .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-text")
                .html("75 GPD");
            $(".wd-compare-detail-flow_rate .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-text")
                .html("0.05 GPM");
            $(".wd-compare-detail-flow_rate .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg_text")
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-flow_none-svg.svg?v=1682313834" alt="">`
                );
            $(".wd-compare-detail-flow_rate .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-subtext-oz")
                .html(`*The capacity of the glass is 8oz`);
            $(".wd-compare-detail-water_capacity_options .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`<div class="wd-compare-detail-item-blacktext">5-mode </div>
        <div class="wd-compare-detail-item-subtext">Customizable Water Capacity</div>`);
            $(".wd-compare-detail-dispensing_option .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .eq(0)
                .html(
                    ` <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dispensing-svg.svg?v=1682313834" alt="">`
                );
            $(".wd-compare-detail-dispensing_option .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .eq(1)
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dispensing-svg.svg?v=1682313834" alt="">`
                );
            $(".wd-compare-detail-dispensing_option .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .eq(2)
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dispensing_none-svg.svg?v=1682313835" alt="">`
                );
            $(".wd-compare-detail-water .wd-compare-detail-item")
                .eq(wd_compare_index)
                .html(`<div class="wd-compare-detail-item-text">110 oz</div>`);
            $(".wd-compare-detail-installation .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`
      <div class="wd-compare-detail-item-svg">
      <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-installation-1-none-svg.svg?v=1682313834" alt="">
  </div>
  <div class="wd-compare-detail-item-subtext">
      No Installation
  </div>
  <div class="wd-compare-detail-item-svg">
      <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-installation-2-none-svg.svg?v=1682313835" alt="">
  </div>
  <div class="wd-compare-detail-item-subtext">
      Drill a hole in the countertop
  </div>
    `);
            $(".wd-compare-detail-dimensions .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-text")
                .html(`15.6" *10.9" *17.0"`);
            $(".wd-compare-detail-item_weight .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-text")
                .html(`14lb`);
            $(".wd-compare-detail-warranty .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-text")
                .html(`1 Year`);
            $(".wd-compare-detail-usage_scenario .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-usage_scenario-svg2.svg?v=1682313835" alt="">`
                );
            $(".wd-compare-detail-usage_scenario .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-text")
                .html(`Countertop`);

            $(".wd-compare-detail-nsf .wd-compare-detail-item").eq(wd_compare_index)
                .html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835"
            alt="">
    </div>`);

            $(".wd-compare-detail-fcc .wd-compare-detail-item").eq(wd_compare_index)
                .html(`<div class="wd-compare-detail-item-img">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-page-icon-2.png?v=1681377284"
            alt="">
    </div>`);

            $(".wd-compare-detail-ce .wd-compare-detail-item").eq(wd_compare_index)
                .html(`<div class="wd-compare-detail-item-img">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-page-icon-3.png?v=1681377284"
            alt="">
    </div>`);

            $(".wd-compare-detail-reddot_design .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835"
            alt="">
    </div>`);

            $(".wd-compare-detail-sgs .wd-compare-detail-item").eq(wd_compare_index)
                .html(`<div class="wd-compare-detail-item-img">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-page-icon-5.png?v=1681377284"
            alt="">
    </div>`);

            $(".wd-compare-detail-tuv .wd-compare-detail-item").eq(wd_compare_index)
                .html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835" alt="">
    </div>`);

            $(".wd-compare-detail-ul .wd-compare-detail-item").eq(wd_compare_index)
                .html(` <div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835" alt="">
    </div>`);

            $(".wd-compare-detail-filtration .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-bigtext")
                .html(`6 Stages`);
            $(".wd-compare-detail-reduce .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-reduce_none-svg.svg?v=1682313834" alt="">
    </div>
    <div class="wd-compare-detail-item-longtext">
    TDS,  PFAS, fluoride, chlorine, inorganic arsenic compounds, salts like nitrate and chloride, viruses, bacteria, and other harmful substances <br><br>
Heavy metals: chromium, lead, arsenic, iron, radium, and calcium<br><br>
Dirt, dust, sand, chlorine, taste and odor, colloid, residual large particles, suspended solids, rust, sediment,  large particles, scale
    </div>`);

            $(".wd-compare-detail-filter_life_span .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`<div class="wd-compare-detail-item-a">
    <a href="https://www.waterdropfilter.com/products/countertop-ro-system-core-system-replacement-filter-c1rf">
        <div class="wd-compare-detail-item-img">
            <img src="https://cdn.shopifycdn.net/s/files/1/0078/6156/7570/files/3_28b6e831-a774-4147-b8c4-498d79867287.jpg?v=1704268955"
                alt="">
        </div>
        <div class="wd-compare-detail-item-text">
        WD-C1RF
        </div>
        <div class="wd-compare-detail-item-text">
        12 Mths
        </div>
    </a>
  </div>`);

            $(".wd-compare-detail-average .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-text")
                .html(`$59.00`);

            $(".wd-compare-detail-filter_life .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-filter.svg?v=1682313834" alt="">`
                );

            $(".wd-compare-detail-tds .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-smart_none-svg.svg?v=1682313834" alt="">`
                );

            $(".wd-compare-detail-temperature .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    ` <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-temperature-svg.svg?v=1682313834" alt="">`
                );

            $(".wd-compare-detail-uv .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-smart_none-svg.svg?v=1682313834" alt="">`
                );

            $(".wd-compare-detail-self .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-self-svg.svg?v=1682313834" alt="">`
                );


            $(".wd-compare-detail-adjustable .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    ` <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-smart_none-svg.svg?v=1682313834" alt="">`
                );
            $(".wd-compare-detail-sound .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-sound-svg.svg?v=1682313834" alt="">`
                );
        } else if (title == "X16") {
            $(".wd-compare-header .wd-compare-header-item")
                .eq(wd_compare_index)
                .find(".wd-compare-header-item-img img")
                .attr(
                    "src",
                    "https://cdn.shopify.com/s/files/1/0078/6156/7570/files/ui-wd-x16-gpd-new.png?v=1710403944"
                );
            $(".wd-compare-product .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-product-img img")
                .attr(
                    "src",
                    "https://cdn.shopify.com/s/files/1/0078/6156/7570/files/ui-wd-x16-gpd-new.png?v=1710403944"
                );
            $(".wd-compare-product .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-product-shop a")
                .attr(
                    "href",
                    "https://www.waterdropfilter.com/products/undersink-reverse-osmosis-system-x16"
                );
            $(".wd-compare-detail-pure .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-3_1-svg.svg?v=1682313834" alt="">`
                );
            $(".wd-compare-detail-flow_capacity .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-text")
                .html("1600 GPD");
            $(".wd-compare-detail-flow_rate .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-text")
                .html("1.11 GPM");
            $(".wd-compare-detail-flow_rate .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg_text")
                .html(`<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-flow-svg.svg?v=1682313834" alt="">
  2s`);
            $(".wd-compare-detail-flow_rate .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-subtext-oz")
                .html(`*The capacity of the glass is 6oz`);
            $(".wd-compare-detail-water_capacity_options .wd-compare-detail-item")
                .eq(wd_compare_index)
                .html(
                    `<div class="wd-compare-detail-item-svg"><img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-water_capacity_none-svg.svg?v=1682313834" alt=""></div>`
                );
            $(".wd-compare-detail-dispensing_option .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .eq(0)
                .html(
                    ` <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dispensing-svg.svg?v=1682313834" alt="">`
                );
            $(".wd-compare-detail-dispensing_option .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .eq(1)
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dispensing_none-svg.svg?v=1682313835" alt="">`
                );
            $(".wd-compare-detail-dispensing_option .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .eq(2)
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dispensing_none-svg.svg?v=1682313835" alt="">`
                );
            $(".wd-compare-detail-water .wd-compare-detail-item")
                .eq(wd_compare_index)
                .html(
                    `<div class="wd-compare-detail-item-svg"><img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-water-tank_none.svg?v=1682315144" alt=""></div>`
                );
            $(".wd-compare-detail-installation .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`
      <div class="wd-compare-detail-item-svg">
      <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-installation-1-svg.svg?v=1682313834" alt="">
  </div>
  <div class="wd-compare-detail-item-subtext">
      Need Installation
  </div>
  <div class="wd-compare-detail-item-svg">
      <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-installation-2-svg.svg?v=1682313834" alt="">
  </div>
  <div class="wd-compare-detail-item-subtext">
      Drill a hole in the countertop
  </div>
    `);
            $(".wd-compare-detail-dimensions .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-text")
                .html(`18.20”*6.25”*16.72”`);
            $(".wd-compare-detail-item_weight .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-text")
                .html(`36.92lb`);
            $(".wd-compare-detail-warranty .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-text")
                .html(`2 Year`);
            $(".wd-compare-detail-usage_scenario .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-usage_scenario-svg1.svg?v=1682313834" alt="">`
                );
            $(".wd-compare-detail-usage_scenario .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-text")
                .html(`Undersink`);

            $(".wd-compare-detail-nsf .wd-compare-detail-item").eq(wd_compare_index)
                .html(`<div class="wd-compare-detail-item-img">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-page-icon-8.png?v=1685341817"
            alt="">
    </div>`);

            $(".wd-compare-detail-fcc .wd-compare-detail-item").eq(wd_compare_index)
                .html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835"
            alt="">
    </div>`);

            $(".wd-compare-detail-ce .wd-compare-detail-item").eq(wd_compare_index)
                .html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835"
            alt="">
    </div>`);

            $(".wd-compare-detail-reddot_design .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`<div class="wd-compare-detail-item-img">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-ro-contrast-2024-5-8-icon.png?v=1715131458"
            alt="">
    </div>`);

            $(".wd-compare-detail-sgs .wd-compare-detail-item").eq(wd_compare_index)
                .html(`<div class="wd-compare-detail-item-img">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-page-icon-5.png?v=1681377284"
            alt="">
    </div>`);

            $(".wd-compare-detail-tuv .wd-compare-detail-item").eq(wd_compare_index)
                .html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835" alt="">
    </div>`);

            $(".wd-compare-detail-ul .wd-compare-detail-item").eq(wd_compare_index)
                .html(` <div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835" alt="">
    </div>`);

            $(".wd-compare-detail-filtration .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-bigtext")
                .html(`11 Stages`);
            $(".wd-compare-detail-reduce .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-reduce-svg.svg?v=1682313834" alt="">
    </div>
    <div class="wd-compare-detail-item-text">
        99.9% UV Sterilization Rate
    </div>
    <div class="wd-compare-detail-item-longtext">
        TDS, PFAS, fluoride, chlorine, inorganic arsenic compounds, salts like nitrate and
        chloride, viruses, bacteria, and other harmful substances<br><br>
        Heavy metals: chromium, lead, arsenic, iron, radium, and calcium<br><br>
        Dirt, dust, sand, chlorine, taste and odor, colloid, residual large particles, suspended
        solids, rust, sediment, large particles,
        scale
    </div>
    <div class="wd-compare-detail-item-a">
    <a
        href="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/WC-13976_58_20230318.pdf?v=1711002285">View
        the report ></a>
</div>
    `);

            $(".wd-compare-detail-filter_life_span .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`<div class="wd-compare-detail-item-a">
    <a href="https://www.waterdropfilter.com/products/x-gush-reverse-osmosis-system-replacement-filter-f1a">
        <div class="wd-compare-detail-item-img">
            <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/ui-wd-f1a.png?v=1710152599"
                alt="">
        </div>
        <div class="wd-compare-detail-item-text">
            WD-F1A
        </div>
        <div class="wd-compare-detail-item-text">
            F1A-12 Mths 
        </div>
    </a>
  </div>
  <div class="wd-compare-detail-item-a">
    <a href="https://www.waterdropfilter.com/products/x-gush-reverse-osmosis-system-replacement-filter-f2">
        <div class="wd-compare-detail-item-img">
            <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/ui-wd-f2.png?v=1710152600"
                alt="">
        </div>
        <div class="wd-compare-detail-item-text">
        WD-F2
        </div>
        <div class="wd-compare-detail-item-text">
        F2-6Mths
        </div>
    </a>
  </div>
  <div class="wd-compare-detail-item-a">
    <a href="https://www.waterdropfilter.com/products/x-gush-reverse-osmosis-system-replacement-filter-x16-f3">
        <div class="wd-compare-detail-item-img">
            <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/ui-wd-x16-f3.png?v=1710152601"
                alt="">
        </div>
        <div class="wd-compare-detail-item-text">
        WD-X16-F3
        </div>
        <div class="wd-compare-detail-item-text">
        F3-24 Mths
        </div>
    </a>
  </div>`);

            $(".wd-compare-detail-average .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-text")
                .html(`$182.97`);

            $(".wd-compare-detail-filter_life .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-filter.svg?v=1682313834" alt="">`
                );

            $(".wd-compare-detail-tds .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-tds-svg.svg?v=1682313834" alt="">`
                );

            $(".wd-compare-detail-temperature .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    ` <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-smart_none-svg.svg?v=1682313834" alt="">`
                );

            $(".wd-compare-detail-uv .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-uv-svg.svg?v=1682313835" alt="">`
                );

            $(".wd-compare-detail-self .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-self-svg.svg?v=1682313834" alt="">`
                );


            $(".wd-compare-detail-adjustable .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    ` <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-contrast-ro-product-icon4.png?v=1715067027" alt="">`
                );
            $(".wd-compare-detail-sound .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-sound-svg.svg?v=1682313834" alt="">`
                );
        } else if (title == "X12") {
            $(".wd-compare-header .wd-compare-header-item")
                .eq(wd_compare_index)
                .find(".wd-compare-header-item-img img")
                .attr(
                    "src",
                    "https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-contrast-ro-v2-x12-img.webp?v=1714965896"
                );
            $(".wd-compare-product .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-product-img img")
                .attr(
                    "src",
                    "https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-contrast-ro-v2-x12-img.webp?v=1714965896"
                );
            $(".wd-compare-product .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-product-shop a")
                .attr(
                    "href",
                    "https://www.waterdropfilter.com/products/reverse-osmosis-system-x12"
                );
            $(".wd-compare-detail-pure .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-3_1-svg.svg?v=1682313834" alt="">`
                );
            $(".wd-compare-detail-flow_capacity .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-text")
                .html("1200 GPD");
            $(".wd-compare-detail-flow_rate .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-text")
                .html("0.83 GPM");
            $(".wd-compare-detail-flow_rate .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg_text")
                .html(`<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-flow-svg.svg?v=1682313834" alt="">
  3s`);
            $(".wd-compare-detail-flow_rate .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-subtext-oz")
                .html(`*The capacity of the glass is 6oz`);
            $(".wd-compare-detail-water_capacity_options .wd-compare-detail-item")
                .eq(wd_compare_index)
                .html(
                    `<div class="wd-compare-detail-item-svg"><img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-water_capacity_none-svg.svg?v=1682313834" alt=""></div>`
                );
            $(".wd-compare-detail-dispensing_option .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .eq(0)
                .html(
                    ` <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dispensing-svg.svg?v=1682313834" alt="">`
                );
            $(".wd-compare-detail-dispensing_option .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .eq(1)
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dispensing_none-svg.svg?v=1682313835" alt="">`
                );
            $(".wd-compare-detail-dispensing_option .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .eq(2)
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dispensing_none-svg.svg?v=1682313835" alt="">`
                );
            $(".wd-compare-detail-water .wd-compare-detail-item")
                .eq(wd_compare_index)
                .html(
                    `<div class="wd-compare-detail-item-svg"><img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-water-tank_none.svg?v=1682315144" alt=""></div>`
                );
            $(".wd-compare-detail-installation .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`
      <div class="wd-compare-detail-item-svg">
      <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-installation-1-svg.svg?v=1682313834" alt="">
  </div>
  <div class="wd-compare-detail-item-subtext">
      Need Installation
  </div>
  <div class="wd-compare-detail-item-svg">
      <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-installation-2-svg.svg?v=1682313834" alt="">
  </div>
  <div class="wd-compare-detail-item-subtext">
      Drill a hole in the countertop
  </div>
    `);
            $(".wd-compare-detail-dimensions .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-text")
                .html(`18.20”*6.25”*16.72”`);
            $(".wd-compare-detail-item_weight .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-text")
                .html(`36.92lb`);
            $(".wd-compare-detail-warranty .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-text")
                .html(`2 Year`);
            $(".wd-compare-detail-usage_scenario .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-usage_scenario-svg1.svg?v=1682313834" alt="">`
                );
            $(".wd-compare-detail-usage_scenario .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-text")
                .html(`Undersink`);

            $(".wd-compare-detail-nsf .wd-compare-detail-item").eq(wd_compare_index)
                .html(`<div class="wd-compare-detail-item-img">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-page-icon-8.png?v=1685341817"
            alt="">
    </div>`);

            $(".wd-compare-detail-fcc .wd-compare-detail-item").eq(wd_compare_index)
                .html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835"
            alt="">
    </div>`);

            $(".wd-compare-detail-ce .wd-compare-detail-item").eq(wd_compare_index)
                .html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835"
            alt="">
    </div>`);

            $(".wd-compare-detail-reddot_design .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`<div class="wd-compare-detail-item-img">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-ro-contrast-2024-5-8-icon.png?v=1715131458"
            alt="">
    </div>`);

            $(".wd-compare-detail-sgs .wd-compare-detail-item").eq(wd_compare_index)
                .html(`<div class="wd-compare-detail-item-img">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-page-icon-5.png?v=1681377284"
            alt="">
    </div>`);

            $(".wd-compare-detail-tuv .wd-compare-detail-item").eq(wd_compare_index)
                .html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835" alt="">
    </div>`);

            $(".wd-compare-detail-ul .wd-compare-detail-item").eq(wd_compare_index)
                .html(` <div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835" alt="">
    </div>`);

            $(".wd-compare-detail-filtration .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-bigtext")
                .html(`11 Stages`);
            $(".wd-compare-detail-reduce .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-reduce-svg.svg?v=1682313834" alt="">
    </div>
    <div class="wd-compare-detail-item-text">
        99.9% UV Sterilization Rate
    </div>
    <div class="wd-compare-detail-item-longtext">
        TDS, PFAS, fluoride, chlorine, inorganic arsenic compounds, salts like nitrate and
        chloride, viruses, bacteria, and other harmful substances<br><br>
        Heavy metals: chromium, lead, arsenic, iron, radium, and calcium<br><br>
        Dirt, dust, sand, chlorine, taste and odor, colloid, residual large particles, suspended
        solids, rust, sediment, large particles,
        scale
    </div>
    <div class="wd-compare-detail-item-a">
                            <a
                                href="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/WC-13976_58_20230318.pdf?v=1711002285">View
                                the report ></a>
                        </div>
    `);

            $(".wd-compare-detail-filter_life_span .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`<div class="wd-compare-detail-item-a">
    <a href="https://www.waterdropfilter.com/products/x-gush-reverse-osmosis-system-replacement-filter-f1a">
        <div class="wd-compare-detail-item-img">
            <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/ui-wd-f1a.png?v=1710152599"
                alt="">
        </div>
        <div class="wd-compare-detail-item-text">
            WD-F1A
        </div>
        <div class="wd-compare-detail-item-text">
            F1A-12 Mths 
        </div>
    </a>
  </div>
  <div class="wd-compare-detail-item-a">
    <a href="https://www.waterdropfilter.com/products/x-gush-reverse-osmosis-system-replacement-filter-f2">
        <div class="wd-compare-detail-item-img">
            <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/ui-wd-f2.png?v=1710152600"
                alt="">
        </div>
        <div class="wd-compare-detail-item-text">
        WD-F2
        </div>
        <div class="wd-compare-detail-item-text">
        F2-6Mths
        </div>
    </a>
  </div>
  <div class="wd-compare-detail-item-a">
    <a href="https://www.waterdropfilter.com/products/x-gush-reverse-osmosis-system-replacement-filter-x12-f3">
        <div class="wd-compare-detail-item-img">
            <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/ui-wd-x12-f3.png?v=1710152600"
                alt="">
        </div>
        <div class="wd-compare-detail-item-text">
        WD-X12-F3
        </div>
        <div class="wd-compare-detail-item-text">
        F3-24 Mths
        </div>
    </a>
  </div>`);

            $(".wd-compare-detail-average .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-text")
                .html(`$182.97`);

            $(".wd-compare-detail-filter_life .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-filter.svg?v=1682313834" alt="">`
                );

            $(".wd-compare-detail-tds .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-tds-svg.svg?v=1682313834" alt="">`
                );

            $(".wd-compare-detail-temperature .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    ` <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-smart_none-svg.svg?v=1682313834" alt="">`
                );

            $(".wd-compare-detail-uv .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-uv-svg.svg?v=1682313835" alt="">`
                );

            $(".wd-compare-detail-self .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-self-svg.svg?v=1682313834" alt="">`
                );


            $(".wd-compare-detail-adjustable .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    ` <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-contrast-ro-product-icon4.png?v=1715067027" alt="">`
                );
            $(".wd-compare-detail-sound .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-sound-svg.svg?v=1682313834" alt="">`
                );
        } else if (title == "X8") {
            $(".wd-compare-header .wd-compare-header-item")
                .eq(wd_compare_index)
                .find(".wd-compare-header-item-img img")
                .attr(
                    "src",
                    "https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-product-1016-advance-product-x8-img1.png?v=1720420379"
                );
            $(".wd-compare-product .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-product-img img")
                .attr(
                    "src",
                    "https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-product-1016-advance-product-x8-img1.png?v=1720420379"
                );
            $(".wd-compare-product .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-product-shop a")
                .attr(
                    "href",
                    "https://www.waterdropfilter.com/products/reverse-osmosis-system-x8"
                );
            $(".wd-compare-detail-pure .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-2_1-svg.svg?v=1682313834" alt="">`
                );
            $(".wd-compare-detail-flow_capacity .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-text")
                .html("800 GPD");
            $(".wd-compare-detail-flow_rate .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-text")
                .html("0.56 GPM");
            $(".wd-compare-detail-flow_rate .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg_text")
                .html(`<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-flow-svg.svg?v=1682313834" alt="">
  6s`);
            $(".wd-compare-detail-flow_rate .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-subtext-oz")
                .html(`*The capacity of the glass is 6oz`);
            $(".wd-compare-detail-water_capacity_options .wd-compare-detail-item")
                .eq(wd_compare_index)
                .html(
                    `<div class="wd-compare-detail-item-svg"><img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-water_capacity_none-svg.svg?v=1682313834" alt=""></div>`
                );
            $(".wd-compare-detail-dispensing_option .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .eq(0)
                .html(
                    ` <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dispensing-svg.svg?v=1682313834" alt="">`
                );
            $(".wd-compare-detail-dispensing_option .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .eq(1)
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dispensing_none-svg.svg?v=1682313835" alt="">`
                );
            $(".wd-compare-detail-dispensing_option .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .eq(2)
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dispensing_none-svg.svg?v=1682313835" alt="">`
                );
            $(".wd-compare-detail-water .wd-compare-detail-item")
                .eq(wd_compare_index)
                .html(
                    `<div class="wd-compare-detail-item-svg"><img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-water-tank_none.svg?v=1682315144" alt=""></div>`
                );
            $(".wd-compare-detail-installation .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`
      <div class="wd-compare-detail-item-svg">
      <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-installation-1-svg.svg?v=1682313834" alt="">
  </div>
  <div class="wd-compare-detail-item-subtext">
      Need Installation
  </div>
  <div class="wd-compare-detail-item-svg">
      <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-installation-2-svg.svg?v=1682313834" alt="">
  </div>
  <div class="wd-compare-detail-item-subtext">
      Drill a hole in the countertop
  </div>
    `);
            $(".wd-compare-detail-dimensions .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-text")
                .html(`24.57”*10.51”*22.8”`);
            $(".wd-compare-detail-item_weight .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-text")
                .html(`36.9lb`);
            $(".wd-compare-detail-warranty .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-text")
                .html(`1 Year`);
            $(".wd-compare-detail-usage_scenario .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-usage_scenario-svg1.svg?v=1682313834" alt="">`
                );
            $(".wd-compare-detail-usage_scenario .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-text")
                .html(`Undersink`);

            $(".wd-compare-detail-nsf .wd-compare-detail-item").eq(wd_compare_index)
                .html(`<div class="wd-compare-detail-item-img">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-page-icon-8.png?v=1685341817"
            alt="">
    </div>`);

            $(".wd-compare-detail-fcc .wd-compare-detail-item").eq(wd_compare_index)
                .html(`<div class="wd-compare-detail-item-img">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-page-icon-2.png?v=1681377284"
            alt="">
    </div>`);

            $(".wd-compare-detail-ce .wd-compare-detail-item").eq(wd_compare_index)
                .html(`<div class="wd-compare-detail-item-img">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-page-icon-3.png?v=1681377284"
            alt="">
    </div>`);

            $(".wd-compare-detail-reddot_design .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`<div class="wd-compare-detail-item-img">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-page-icon-4.png?v=1681377284"
            alt="">
    </div>`);

            $(".wd-compare-detail-sgs .wd-compare-detail-item").eq(wd_compare_index)
                .html(`<div class="wd-compare-detail-item-img">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-page-icon-5.png?v=1681377284"
            alt="">
    </div>`);

            $(".wd-compare-detail-tuv .wd-compare-detail-item").eq(wd_compare_index)
                .html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835" alt="">
    </div>`);

            $(".wd-compare-detail-ul .wd-compare-detail-item").eq(wd_compare_index)
                .html(` <div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835" alt="">
    </div>`);

            $(".wd-compare-detail-filtration .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-bigtext")
                .html(`9 Stages`);
            $(".wd-compare-detail-reduce .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-reduce-svg.svg?v=1682313834" alt="">
    </div>
    <div class="wd-compare-detail-item-text">
        99.9% UV Sterilization Rate
    </div>
    <div class="wd-compare-detail-item-longtext">
        TDS, PFAS, fluoride, chlorine, inorganic arsenic compounds, salts like nitrate and
        chloride, viruses, bacteria, and other harmful substances<br><br>
        Heavy metals: chromium, lead, arsenic, iron, radium, and calcium<br><br>
        Dirt, dust, sand, chlorine, taste and odor, colloid, residual large particles, suspended
        solids, rust, sediment, large particles,
        scale
    </div>
    `);

            $(".wd-compare-detail-filter_life_span .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`<div class="wd-compare-detail-item-a">
    <a href="https://www.waterdropfilter.com/products/x-series-reverse-osmosis-system-replacement-filter-f1g">
        <div class="wd-compare-detail-item-img">
            <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/ui-wd-f1g.png?v=1719919472"
                alt="">
        </div>
        <div class="wd-compare-detail-item-text">
            WD-F1G
        </div>
        <div class="wd-compare-detail-item-text">
            F1G-12 Mths 
        </div>
    </a>
  </div>
  <div class="wd-compare-detail-item-a">
    <a href="https://www.waterdropfilter.com/products/x-series-reverse-osmosis-filter-replacement-filter-f2">
        <div class="wd-compare-detail-item-img">
            <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/ui-wd-f2.png?v=1710152600"
                alt="">
        </div>
        <div class="wd-compare-detail-item-text">
        WD-F2
        </div>
        <div class="wd-compare-detail-item-text">
        F2-6 Mths
        </div>
    </a>
  </div>
  <div class="wd-compare-detail-item-a">
    <a href="https://www.waterdropfilter.com/products/x-series-undersink-ro-system-replacement-filter-x8-f3">
        <div class="wd-compare-detail-item-img">
            <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/ui-wd-x8-f3.png?v=1719919462"
                alt="">
        </div>
        <div class="wd-compare-detail-item-text">
        WD-X8-F3
        </div>
        <div class="wd-compare-detail-item-text">
        F3-24 Mths
        </div>
    </a>
  </div>`);

            $(".wd-compare-detail-average .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-text")
                .html(`$229.96`);

            $(".wd-compare-detail-filter_life .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-filter.svg?v=1682313834" alt="">`
                );

            $(".wd-compare-detail-tds .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-tds-svg.svg?v=1682313834" alt="">`
                );

            $(".wd-compare-detail-temperature .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    ` <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-smart_none-svg.svg?v=1682313834" alt="">`
                );

            $(".wd-compare-detail-uv .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-uv-svg.svg?v=1682313835" alt="">`
                );

            $(".wd-compare-detail-self .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-self-svg.svg?v=1682313834" alt="">`
                );


            $(".wd-compare-detail-adjustable .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    ` <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-contrast-ro-product-icon4.png?v=1715067027" alt="">`
                );
            $(".wd-compare-detail-sound .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-sound-svg.svg?v=1682313834" alt="">`
                );
        } else if (title == "A2") {
            $(".wd-compare-header .wd-compare-header-item")
                .eq(wd_compare_index)
                .find(".wd-compare-header-item-img img")
                .attr(
                    "src",
                    "https://cdn.shopify.com/s/files/1/0078/6156/7570/files/WD-A2.png?v=1727599788"
                );
            $(".wd-compare-product .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-product-img img")
                .attr(
                    "src",
                    "https://cdn.shopify.com/s/files/1/0078/6156/7570/files/WD-A2.png?v=1727599788"
                );
            $(".wd-compare-product .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-product-shop a")
                .attr(
                    "href",
                    "https://www.waterdropfilter.com/collections/countertop-ro-systems/products/reverse-osmosis-hot-and-cold-water-dispenser-a2"
                );
            $(".wd-compare-detail-pure .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-3_1-svg.svg?v=1682313834" alt="">`
                );
            $(".wd-compare-detail-flow_capacity .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-text")
                .html("100 GPD");
            $(".wd-compare-detail-flow_rate .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-text")
                .html("0.07 GPM");
            $(".wd-compare-detail-flow_rate .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg_text")
                .html(`<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-flow_none-svg.svg?v=1682313834" alt="">`);
            $(".wd-compare-detail-flow_rate .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-subtext-oz")
                .html(`*The capacity of the glass is 6oz`);
            $(".wd-compare-detail-water_capacity_options .wd-compare-detail-item")
                .eq(wd_compare_index)
                .html(
                    `<div class="wd-compare-detail-item-blacktext">5-mode </div>
                    <div class="wd-compare-detail-item-subtext">Customizable Water Capacity</div>`
                );
            $(".wd-compare-detail-dispensing_option .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .eq(0)
                .html(
                    ` <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dispensing-svg.svg?v=1682313834" alt="">`
                );
            $(".wd-compare-detail-dispensing_option .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .eq(1)
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dispensing-svg.svg?v=1682313834" alt="">`
                );
            $(".wd-compare-detail-dispensing_option .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .eq(2)
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dispensing-svg.svg?v=1682313834" alt="">`
                );
            $(".wd-compare-detail-water .wd-compare-detail-item")
                .eq(wd_compare_index)
                .html(
                    `<div class="wd-compare-detail-item-text">159 oz</div>`
                );
            $(".wd-compare-detail-installation .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`
      <div class="wd-compare-detail-item-svg">
      <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-installation-1-none-svg.svg?v=1682313834" alt="">
  </div>
  <div class="wd-compare-detail-item-subtext">
        No Installation   
  </div>
  <div class="wd-compare-detail-item-svg">
      <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-installation-2-none-svg.svg?v=1682313835" alt="">
  </div>
  <div class="wd-compare-detail-item-subtext">
      Drill a hole in the countertop
  </div>
    `);
            $(".wd-compare-detail-dimensions .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-text")
                .html(`15.9”*8.2”*15.7”`);
            $(".wd-compare-detail-item_weight .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-text")
                .html(`22lb`);
            $(".wd-compare-detail-warranty .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-text")
                .html(`1 Year`);
            $(".wd-compare-detail-usage_scenario .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-usage_scenario-svg2.svg?v=1682313835" alt="">`
                );
            $(".wd-compare-detail-usage_scenario .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-text")
                .html(`Countertop`);

            $(".wd-compare-detail-nsf .wd-compare-detail-item").eq(wd_compare_index)
                .html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-page-icon-8.png?v=1685341817"
            alt="">
    </div>`);

            $(".wd-compare-detail-fcc .wd-compare-detail-item").eq(wd_compare_index)
                .html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835"
            alt="">
    </div>`);

            $(".wd-compare-detail-ce .wd-compare-detail-item").eq(wd_compare_index)
                .html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835"
            alt="">
    </div>`);

            $(".wd-compare-detail-reddot_design .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835"
            alt="">
    </div>`);

            $(".wd-compare-detail-sgs .wd-compare-detail-item").eq(wd_compare_index)
                .html(`<div class="wd-compare-detail-item-img">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-page-icon-5.png?v=1681377284"
            alt="">
    </div>`);

            $(".wd-compare-detail-tuv .wd-compare-detail-item").eq(wd_compare_index)
                .html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835" alt="">
    </div>`);

            $(".wd-compare-detail-ul .wd-compare-detail-item").eq(wd_compare_index)
                .html(` <div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835" alt="">
    </div>`);

            $(".wd-compare-detail-filtration .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-bigtext")
                .html(`5 Stages`);
            $(".wd-compare-detail-reduce .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-reduce-svg.svg?v=1682313834" alt="">
    </div>
    <div class="wd-compare-detail-item-text">
        99.9% UV Sterilization Rate
    </div>
    <div class="wd-compare-detail-item-longtext">
        TDS, PFAS, fluoride, chlorine, inorganic arsenic compounds, salts like nitrate and chloride, viruses, bacteria, and other harmful substances <br><br>
        Heavy metals: chromium, lead, arsenic, iron, radium, and calcium<br><br>
        Dirt, dust, sand, chlorine, taste and odor, colloid, residual large particles, suspended solids, rust, sediment, large particles, scale
    </div>
    `);

            $(".wd-compare-detail-filter_life_span .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`<div class="wd-compare-detail-item-a">
    <a href="https://www.waterdropfilter.com/products/replacement-for-a2-countertop-ro-system-a2rf-ro">
        <div class="wd-compare-detail-item-img">
            <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/WD-A2RF-RO.png?v=1728454088"
                alt="">
        </div>
        <div class="wd-compare-detail-item-text">
            WD-A2RF-RO
        </div>
        <div class="wd-compare-detail-item-text">
            12 Mths 
        </div>
    </a>
  </div>
  `);

            $(".wd-compare-detail-average .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-text")
                .html(`$69.99`);

            $(".wd-compare-detail-filter_life .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-filter.svg?v=1682313834" alt="">`
                );

            $(".wd-compare-detail-tds .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-tds-svg.svg?v=1682313834" alt="">`
                );

            $(".wd-compare-detail-temperature .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    ` <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-smart_none-svg.svg?v=1682313834" alt="">`
                );

            $(".wd-compare-detail-uv .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-uv-svg.svg?v=1682313835" alt="">`
                );

            $(".wd-compare-detail-self .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-self-svg.svg?v=1682313834" alt="">`
                );


            $(".wd-compare-detail-adjustable .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    ` <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-contrast-ro-product-icon4.png?v=1715067027" alt="">`
                );
            $(".wd-compare-detail-sound .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-sound-svg.svg?v=1682313834" alt="">`
                );
        } else if (title == "K19-SFK") {
            $(".wd-compare-header .wd-compare-header-item")
                .eq(wd_compare_index)
                .find(".wd-compare-header-item-img img")
                .attr(
                    "src",
                    "https://cdn.shopify.com/s/files/1/0078/6156/7570/files/ui-wd-k19-sfk.png?v=1730792490"
                );
            $(".wd-compare-product .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-product-img img")
                .attr(
                    "src",
                    "https://cdn.shopify.com/s/files/1/0078/6156/7570/files/ui-wd-k19-sfk.png?v=1730792490"
                );
            $(".wd-compare-product .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-product-shop a")
                .attr(
                    "href",
                    "https://www.waterdropfilter.com/products/countertop-ro-water-filter-k19-sfk"
                );
            $(".wd-compare-detail-pure .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-3_1-svg.svg?v=1682313834" alt="">`
                );
            $(".wd-compare-detail-flow_capacity .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-text")
                .html("75 GPD");
            $(".wd-compare-detail-flow_rate .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-text")
                .html("0.05 GPM");
            $(".wd-compare-detail-flow_rate .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg_text")
                .html(`<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-flow_none-svg.svg?v=1682313834" alt="">`);
            $(".wd-compare-detail-flow_rate .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-subtext-oz")
                .html(`*The capacity of the glass is 6oz`);
            $(".wd-compare-detail-water_capacity_options .wd-compare-detail-item")
                .eq(wd_compare_index)
                .html(
                    `<div class="wd-compare-detail-item-blacktext">4-mode </div>
        <div class="wd-compare-detail-item-subtext">Customizable Water Capacity</div>`
                );
            $(".wd-compare-detail-dispensing_option .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .eq(0)
                .html(
                    ` <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dispensing-svg.svg?v=1682313834" alt="">`
                );
            $(".wd-compare-detail-dispensing_option .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .eq(1)
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dispensing_none-svg.svg?v=1682313835" alt="">`
                );
            $(".wd-compare-detail-dispensing_option .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .eq(2)
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dispensing_none-svg.svg?v=1682313835" alt="">`
                );
            $(".wd-compare-detail-water .wd-compare-detail-item")
                .eq(wd_compare_index)
                .html(
                    `<div class="wd-compare-detail-item-text">170 oz</div>`
                );
            $(".wd-compare-detail-installation .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`
      <div class="wd-compare-detail-item-svg">
      <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-installation-1-none-svg.svg?v=1682313834" alt="">
  </div>
  <div class="wd-compare-detail-item-subtext">
    No Installation   
  </div>
  <div class="wd-compare-detail-item-svg">
      <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-installation-2-none-svg.svg?v=1682313835" alt="">
  </div>
  <div class="wd-compare-detail-item-subtext">
      Drill a hole in the countertop
  </div>
    `);
            $(".wd-compare-detail-dimensions .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-text")
                .html(`15.51"*9.2”*17.56"`);
            $(".wd-compare-detail-item_weight .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-text")
                .html(`16.3lb`);
            $(".wd-compare-detail-warranty .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-text")
                .html(`1 Year`);
            $(".wd-compare-detail-usage_scenario .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-usage_scenario-svg2.svg?v=1682313835" alt="">`
                );
            $(".wd-compare-detail-usage_scenario .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-text")
                .html(`Countertop`);

            $(".wd-compare-detail-nsf .wd-compare-detail-item").eq(wd_compare_index)
                .html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835"
            alt="">
    </div>`);

            $(".wd-compare-detail-fcc .wd-compare-detail-item").eq(wd_compare_index)
                .html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835"
            alt="">
    </div>`);

            $(".wd-compare-detail-ce .wd-compare-detail-item").eq(wd_compare_index)
                .html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835"
            alt="">
    </div>`);

            $(".wd-compare-detail-reddot_design .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835"
            alt="">
    </div>`);

            $(".wd-compare-detail-sgs .wd-compare-detail-item").eq(wd_compare_index)
                .html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835"
            alt="">
    </div>`);

            $(".wd-compare-detail-tuv .wd-compare-detail-item").eq(wd_compare_index)
                .html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835" alt="">
    </div>`);

            $(".wd-compare-detail-ul .wd-compare-detail-item").eq(wd_compare_index)
                .html(` <div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835" alt="">
    </div>`);

            $(".wd-compare-detail-filtration .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-bigtext")
                .html(`7 Stages`);
            $(".wd-compare-detail-reduce .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-reduce-svg.svg?v=1682313834" alt="">
    </div>
    <div class="wd-compare-detail-item-text">
        99.9% UV Sterilization Rate
    </div>
    <div class="wd-compare-detail-item-longtext">
    TDS, PFAS, fluoride, chlorine, inorganic arsenic compounds, salts like nitrate and chloride, viruses, bacteria, and other harmful substances <br><br>
    Heavy metals: chromium, lead, arsenic, iron, radium, and calcium<br><br>
    Dirt, dust, sand, chlorine, taste and odor, colloid, residual large particles, suspended solids, rust, sediment, large particles, scale
    </div>
    `);

            $(".wd-compare-detail-filter_life_span .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`<div class="wd-compare-detail-item-a">
    <a href="https://www.waterdropfilter.com/products/countertop-ro-system-replacement-filter-k19-rf-fk">
        <div class="wd-compare-detail-item-img">
            <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/WD-K19RF-FK.png?v=1734932272"
                alt="">
        </div>
        <div class="wd-compare-detail-item-text">
            WD-K19RF-FK
        </div>
        <div class="wd-compare-detail-item-text">
            12 Mths
        </div>
    </a>
  </div>
  `);

            $(".wd-compare-detail-average .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-text")
                .html(`$78.99`);

            $(".wd-compare-detail-filter_life .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-filter.svg?v=1682313834" alt="">`
                );

            $(".wd-compare-detail-tds .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-tds-svg.svg?v=1682313834" alt="">`
                );

            $(".wd-compare-detail-temperature .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    ` <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-smart_none-svg.svg?v=1682313834" alt="">`
                );

            $(".wd-compare-detail-uv .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-uv-svg.svg?v=1682313835" alt="">`
                );

            $(".wd-compare-detail-self .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-self-svg.svg?v=1682313834" alt="">`
                );


            $(".wd-compare-detail-adjustable .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    ` <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-contrast-ro-product-icon4.png?v=1715067027" alt="">`
                );
            $(".wd-compare-detail-sound .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-sound-svg.svg?v=1682313834" alt="">`
                );
        } else if (title == "C1SL") {
            $(".wd-compare-header .wd-compare-header-item")
                .eq(wd_compare_index)
                .find(".wd-compare-header-item-img img")
                .attr(
                    "src",
                    "https://cdn.shopify.com/s/files/1/0078/6156/7570/files/ui-WD-C1SL-PH.png?v=1737632900"
                );
            $(".wd-compare-product .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-product-img img")
                .attr(
                    "src",
                    "https://cdn.shopify.com/s/files/1/0078/6156/7570/files/ui-WD-C1SL-PH.png?v=1737632900"
                );
            $(".wd-compare-product .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-product-shop a")
                .attr(
                    "href",
                    "https://www.waterdropfilter.com/collections/countertop-ro-systems/products/waterdrop-remineralization-countertop-corero-system-c1sl"
                );
            $(".wd-compare-detail-pure .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-3_1-svg.svg?v=1682313834" alt="">`
                );
            $(".wd-compare-detail-flow_capacity .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-text")
                .html("75 GPD");
            $(".wd-compare-detail-flow_rate .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-text")
                .html("0.05 GPM");
            $(".wd-compare-detail-flow_rate .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg_text")
                .html(`<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-flow_none-svg.svg?v=1682313834" alt="">`);
            $(".wd-compare-detail-flow_rate .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-subtext-oz")
                .html(`*The capacity of the glass is 6oz`);
            $(".wd-compare-detail-water_capacity_options .wd-compare-detail-item")
                .eq(wd_compare_index)
                .html(
                    `
                    <div class="wd-compare-detail-item-blacktext">5-mode </div>
                    <div class="wd-compare-detail-item-subtext">Customizable Water Capacity</div>`
                );
            $(".wd-compare-detail-dispensing_option .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .eq(0)
                .html(
                    ` <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dispensing-svg.svg?v=1682313834" alt="">`
                );
            $(".wd-compare-detail-dispensing_option .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .eq(1)
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dispensing_none-svg.svg?v=1682313835" alt="">`
                );
            $(".wd-compare-detail-dispensing_option .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .eq(2)
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dispensing_none-svg.svg?v=1682313835" alt="">`
                );
            $(".wd-compare-detail-water .wd-compare-detail-item")
                .eq(wd_compare_index)
                .html(
                    `<div class="wd-compare-detail-item-text">110 oz</div>`
                );
            $(".wd-compare-detail-installation .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`
      <div class="wd-compare-detail-item-svg">
      <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-installation-1-none-svg.svg?v=1682313834" alt="">
  </div>
  <div class="wd-compare-detail-item-subtext">
    No Installation   
  </div>
  <div class="wd-compare-detail-item-svg">
      <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-installation-2-none-svg.svg?v=1682313835" alt="">
  </div>
  <div class="wd-compare-detail-item-subtext">
      Drill a hole in the countertop
  </div>
    `);
            $(".wd-compare-detail-dimensions .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-text")
                .html(`15.6" *10.9" *17.0"`);
            $(".wd-compare-detail-item_weight .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-text")
                .html(`14 lb`);
            $(".wd-compare-detail-warranty .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-text")
                .html(`1 Year`);
            $(".wd-compare-detail-usage_scenario .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-usage_scenario-svg2.svg?v=1682313835" alt="">`
                );
            $(".wd-compare-detail-usage_scenario .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-text")
                .html(`Countertop`);

            $(".wd-compare-detail-nsf .wd-compare-detail-item").eq(wd_compare_index)
                .html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835"
            alt="">
    </div>`);

            $(".wd-compare-detail-fcc .wd-compare-detail-item").eq(wd_compare_index)
                .html(`<div class="wd-compare-detail-item-img">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-page-icon-2.png?v=1681377284"
            alt="">
    </div>`);

            $(".wd-compare-detail-ce .wd-compare-detail-item").eq(wd_compare_index)
                .html(`<div class="wd-compare-detail-item-img">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-page-icon-3.png?v=1681377284"
            alt="">
    </div>`);

            $(".wd-compare-detail-reddot_design .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835"
            alt="">
    </div>`);

            $(".wd-compare-detail-sgs .wd-compare-detail-item").eq(wd_compare_index)
                .html(`<div class="wd-compare-detail-item-img">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-page-icon-5.png?v=1681377284"
            alt="">
    </div>`);

            $(".wd-compare-detail-tuv .wd-compare-detail-item").eq(wd_compare_index)
                .html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835" alt="">
    </div>`);

            $(".wd-compare-detail-ul .wd-compare-detail-item").eq(wd_compare_index)
                .html(` <div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835" alt="">
    </div>`);

            $(".wd-compare-detail-filtration .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-bigtext")
                .html(`7 Stages`);
            $(".wd-compare-detail-reduce .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-reduce_none-svg.svg?v=1682313834" alt="">
    </div>
    <div class="wd-compare-detail-item-longtext">
    TDS, PFAS, fluoride, chlorine, inorganic arsenic compounds, salts like nitrate and chloride, viruses, bacteria, and other harmful substances <br><br>
Heavy metals: chromium, lead, arsenic, iron, radium, and calcium<br><br>

Dirt, dust, sand, chlorine, taste and odor, colloid, residual large particles, suspended solids, rust, sediment, large particles, scale
    </div>
    <div class="wd-compare-detail-item-a">
        <a href="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/Specification_Sheet_for_Reducing_Harmful_Substances-WD-C1.pdf?v=1705030291)">View
            the report &gt;</a>
    </div>
    `);

            $(".wd-compare-detail-filter_life_span .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`<div class="wd-compare-detail-item-a">
    <a href="https://www.waterdropfilter.com/products/countertop-corero-system-replacement-filter-c1rfg">
        <div class="wd-compare-detail-item-img">
            <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/WD-C1RFG_2.png?v=1737085105"
                alt="">
        </div>
        <div class="wd-compare-detail-item-text">
        WD-C1RFG    
        </div>
        <div class="wd-compare-detail-item-text">
            12 Mths
        </div>
    </a>
  </div>
  `);

            $(".wd-compare-detail-average .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-text")
                .html(`$69.99`);

            $(".wd-compare-detail-filter_life .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-filter.svg?v=1682313834" alt="">`
                );

            $(".wd-compare-detail-tds .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-tds-svg.svg?v=1682313834" alt="">`
                );

            $(".wd-compare-detail-temperature .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    ` <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-smart_none-svg.svg?v=1682313834" alt="">`
                );

            $(".wd-compare-detail-uv .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-smart_none-svg.svg?v=1682313834" alt="">`
                );

            $(".wd-compare-detail-self .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-self-svg.svg?v=1682313834" alt="">`
                );


            $(".wd-compare-detail-adjustable .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    ` <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-smart_none-svg.svg?v=1682313834" alt="">`
                );
            $(".wd-compare-detail-sound .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-sound-svg.svg?v=1682313834" alt="">`
                );
        } else if (title == "M1") {
            $(".wd-compare-header .wd-compare-header-item")
                .eq(wd_compare_index)
                .find(".wd-compare-header-item-img img")
                .attr(
                    "src",
                    "https://cdn.shopify.com/s/files/1/0078/6156/7570/files/ui-WD-M1-product-W.png?v=1736152999"
                );
            $(".wd-compare-product .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-product-img img")
                .attr(
                    "src",
                    "https://cdn.shopify.com/s/files/1/0078/6156/7570/files/ui-WD-M1-product-W.png?v=1736152999"
                );
            $(".wd-compare-product .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-product-shop a")
                .attr(
                    "href",
                    "https://www.waterdropfilter.com/collections/countertop-ro-systems/products/countertop-instant-hot-m1-ro-dispenser"
                );
            $(".wd-compare-detail-pure .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-3_1-svg.svg?v=1682313834" alt="">`
                );
            $(".wd-compare-detail-flow_capacity .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-text")
                .html("75 GPD");
            $(".wd-compare-detail-flow_rate .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-text")
                .html("0.05 GPM");
            $(".wd-compare-detail-flow_rate .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg_text")
                .html(`<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-flow_none-svg.svg?v=1682313834" alt="">`);
            $(".wd-compare-detail-flow_rate .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-subtext-oz")
                .html(`*The capacity of the glass is 6oz`);
            $(".wd-compare-detail-water_capacity_options .wd-compare-detail-item")
                .eq(wd_compare_index)
                .html(
                    `
                    <div class="wd-compare-detail-item-blacktext">6-mode </div>
                    <div class="wd-compare-detail-item-subtext">Customizable Water Capacity</div>`
                );
            $(".wd-compare-detail-dispensing_option .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .eq(0)
                .html(
                    ` <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dispensing-svg.svg?v=1682313834" alt="">`
                );
            $(".wd-compare-detail-dispensing_option .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .eq(1)
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dispensing-svg.svg?v=1682313834" alt="">`
                );
            $(".wd-compare-detail-dispensing_option .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .eq(2)
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dispensing_none-svg.svg?v=1682313835" alt="">`
                );
            $(".wd-compare-detail-water .wd-compare-detail-item")
                .eq(wd_compare_index)
                .html(
                    `<div class="wd-compare-detail-item-text">110 oz</div>`
                );
            $(".wd-compare-detail-installation .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`
      <div class="wd-compare-detail-item-svg">
      <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-installation-1-none-svg.svg?v=1682313834" alt="">
  </div>
  <div class="wd-compare-detail-item-subtext">
    No Installation   
  </div>
  <div class="wd-compare-detail-item-svg">
      <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-installation-2-none-svg.svg?v=1682313835" alt="">
  </div>
  <div class="wd-compare-detail-item-subtext">
      Drill a hole in the countertop
  </div>
    `);
            $(".wd-compare-detail-dimensions .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-text")
                .html(`9.65" * 12.72" * 15.51"`);
            $(".wd-compare-detail-item_weight .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-text")
                .html(`15.4 lb`);
            $(".wd-compare-detail-warranty .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-text")
                .html(`1 Year`);
            $(".wd-compare-detail-usage_scenario .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-usage_scenario-svg2.svg?v=1682313835" alt="">`
                );
            $(".wd-compare-detail-usage_scenario .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-text")
                .html(`Countertop`);

            $(".wd-compare-detail-nsf .wd-compare-detail-item").eq(wd_compare_index)
                .html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835"
            alt="">
    </div>`);

            $(".wd-compare-detail-fcc .wd-compare-detail-item").eq(wd_compare_index)
                .html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835"
            alt="">
    </div>`);

            $(".wd-compare-detail-ce .wd-compare-detail-item").eq(wd_compare_index)
                .html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835"
            alt="">
    </div>`);

            $(".wd-compare-detail-reddot_design .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835"
            alt="">
    </div>`);

            $(".wd-compare-detail-sgs .wd-compare-detail-item").eq(wd_compare_index)
                .html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835"
            alt="">
    </div>`);

            $(".wd-compare-detail-tuv .wd-compare-detail-item").eq(wd_compare_index)
                .html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835" alt="">
    </div>`);

            $(".wd-compare-detail-ul .wd-compare-detail-item").eq(wd_compare_index)
                .html(` <div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835" alt="">
    </div>`);

            $(".wd-compare-detail-filtration .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-bigtext")
                .html(`6 Stages`);
            $(".wd-compare-detail-reduce .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-reduce_none-svg.svg?v=1682313834" alt="">
    </div>
    <div class="wd-compare-detail-item-longtext">
    TDS, PFAS, fluoride, chlorine, inorganic arsenic compounds, salts like nitrate and chloride, viruses, bacteria, and other harmful substances <br><br>
Heavy metals: chromium, lead, arsenic, iron, radium, and calcium<br><br>

Dirt, dust, sand, chlorine, taste and odor, colloid, residual large particles, suspended solids, rust, sediment, large particles, scale
    </div>
    `);

            $(".wd-compare-detail-filter_life_span .wd-compare-detail-item").eq(
                wd_compare_index
            ).html(`<div class="wd-compare-detail-item-a">
    <a href="https://www.waterdropfilter.com/products/replacement-filter-for-m1">
        <div class="wd-compare-detail-item-img">
            <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/ui-wd-m1rf-product-image_1.png?v=1735790652"
                alt="">
        </div>
        <div class="wd-compare-detail-item-text">
        WD-M1RF
        </div>
        <div class="wd-compare-detail-item-text">
            12 Mths
        </div>
    </a>
  </div>
  `);

            $(".wd-compare-detail-average .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-text")
                .html(`$79.99`);

            $(".wd-compare-detail-filter_life .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-filter.svg?v=1682313834" alt="">`
                );

            $(".wd-compare-detail-tds .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-tds-svg.svg?v=1682313834" alt="">`
                );

            $(".wd-compare-detail-temperature .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    ` <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-temperature-svg.svg?v=1682313834" alt="">`
                );

            $(".wd-compare-detail-uv .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-smart_none-svg.svg?v=1682313834" alt="">`
                );

            $(".wd-compare-detail-self .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-self-svg.svg?v=1682313834" alt="">`
                );


            $(".wd-compare-detail-adjustable .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    ` <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-smart_none-svg.svg?v=1682313834" alt="">`
                );
            $(".wd-compare-detail-sound .wd-compare-detail-item")
                .eq(wd_compare_index)
                .find(".wd-compare-detail-item-svg")
                .html(
                    `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-sound-svg.svg?v=1682313834" alt="">`
                );
        }
    }
});
